/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const blueprintsByCompanyId = /* GraphQL */ `query BlueprintsByCompanyId(
  $companyId: String!
  $filter: ModelAxleBlueprintFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  blueprintsByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      axles
      centerlineLength
      companyId
      createdAt
      description
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BlueprintsByCompanyIdQueryVariables,
  APITypes.BlueprintsByCompanyIdQuery
>;
export const businessAdminsByCognitoId = /* GraphQL */ `query BusinessAdminsByCognitoId(
  $cognitoId: String!
  $filter: ModelBusinessAdminFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  businessAdminsByCognitoId(
    cognitoId: $cognitoId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      cognitoId
      createdAt
      domain
      email
      id
      name
      owner
      permissions
      role
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BusinessAdminsByCognitoIdQueryVariables,
  APITypes.BusinessAdminsByCognitoIdQuery
>;
export const changeLogEntriesByUserIdAndCreatedAt = /* GraphQL */ `query ChangeLogEntriesByUserIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelChangeLogEntryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  changeLogEntriesByUserIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      changedBy
      changedByName
      companyId
      createdAt
      description
      fieldName
      id
      newValue
      oldValue
      owner
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ChangeLogEntriesByUserIdAndCreatedAtQueryVariables,
  APITypes.ChangeLogEntriesByUserIdAndCreatedAtQuery
>;
export const classificationsByCompanyId = /* GraphQL */ `query ClassificationsByCompanyId(
  $companyId: String!
  $filter: ModelClassificationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  classificationsByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClassificationsByCompanyIdQueryVariables,
  APITypes.ClassificationsByCompanyIdQuery
>;
export const companyOwnersByCognitoId = /* GraphQL */ `query CompanyOwnersByCognitoId(
  $cognitoId: String!
  $filter: ModelCompanyOwnerFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  companyOwnersByCognitoId(
    cognitoId: $cognitoId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      cognitoId
      companyId
      contactPhoneNumber
      createdAt
      discrepancyNotification
      discrepancyNotificationTypes
      domain
      email
      id
      name
      owner
      permissions
      pmNotification
      pmNotificationTypes
      role
      siteAdmin
      subscriptionType
      trainingNotification
      trainingNotificationTypes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CompanyOwnersByCognitoIdQueryVariables,
  APITypes.CompanyOwnersByCognitoIdQuery
>;
export const getArchivedDiscrepancy = /* GraphQL */ `query GetArchivedDiscrepancy($id: ID!) {
  getArchivedDiscrepancy(id: $id) {
    archivedDate
    companyId
    createdAt
    downReason
    equipmentId
    equipmentName
    id
    initialStatus
    log
    owner
    promptDescription
    promptLabel
    promptTitle
    questionIndex
    reportId
    status
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetArchivedDiscrepancyQueryVariables,
  APITypes.GetArchivedDiscrepancyQuery
>;
export const getAuditLog = /* GraphQL */ `query GetAuditLog($id: ID!) {
  getAuditLog(id: $id) {
    action
    companyId
    createdAt
    details
    id
    resourceId
    resourceName
    resourceType
    ttl
    updatedAt
    userId
    userName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAuditLogQueryVariables,
  APITypes.GetAuditLogQuery
>;
export const getAxleBlueprint = /* GraphQL */ `query GetAxleBlueprint($id: ID!) {
  getAxleBlueprint(id: $id) {
    axles
    centerlineLength
    companyId
    createdAt
    description
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAxleBlueprintQueryVariables,
  APITypes.GetAxleBlueprintQuery
>;
export const getBillingRate = /* GraphQL */ `query GetBillingRate($id: ID!) {
  getBillingRate(id: $id) {
    companyId
    createdAt
    id
    owner
    ratePerCostTracking
    ratePerEquipment
    ratePerPM
    ratePerSafetyEnrollment
    ratePerSkillQualification
    ratePerTireMaint
    ratePerUser
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBillingRateQueryVariables,
  APITypes.GetBillingRateQuery
>;
export const getBusinessAdmin = /* GraphQL */ `query GetBusinessAdmin($id: ID!) {
  getBusinessAdmin(id: $id) {
    cognitoId
    createdAt
    domain
    email
    id
    name
    owner
    permissions
    role
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBusinessAdminQueryVariables,
  APITypes.GetBusinessAdminQuery
>;
export const getChangeLogEntry = /* GraphQL */ `query GetChangeLogEntry($id: ID!) {
  getChangeLogEntry(id: $id) {
    changedBy
    changedByName
    companyId
    createdAt
    description
    fieldName
    id
    newValue
    oldValue
    owner
    updatedAt
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetChangeLogEntryQueryVariables,
  APITypes.GetChangeLogEntryQuery
>;
export const getClassification = /* GraphQL */ `query GetClassification($id: ID!) {
  getClassification(id: $id) {
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClassificationQueryVariables,
  APITypes.GetClassificationQuery
>;
export const getCompany = /* GraphQL */ `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    accountNumber
    accountOrigin
    accountStatus
    addOnGracePeriodEndDate
    archived
    assignedRep
    billingAnchorDay
    billingContactAddress
    billingContactEmail
    billingContactName
    billingContactPhone
    billingCycle
    businessType
    cancelEffectiveDate
    cancelReason
    cancelReasonNote
    cancelRequestedAt
    companyOwnerId
    coreMonthlyRate
    costTrackingModuleEnrollment
    createdAt
    dataRetentionEndDate
    description
    gracePeriodEndDate
    id
    industryNAICS
    industrySIC
    initialContactDate
    initialStarterPackageEnrollment
    logo
    maxNumberEquipment
    maxNumberUsers
    name
    nextBillingDate
    notes
    numberOfUsers
    paidStartDate
    paymentFailedAt
    paymentMethod
    pmModuleEnrollment
    primaryContactEmail
    primaryContactName
    primaryContactPhone
    primaryContactPosition
    primaryLocation
    referredBy
    retryAttempts
    safetyComplianceStandard
    secondaryContactEmail
    secondaryContactName
    secondaryContactPhone
    secondaryContactPosition
    skillTrackingModuleEnrollment
    starterPackage
    status
    subscriptionExpiration
    subscriptionType
    tiresModuleEnrollment
    trainingModuleEnrollment
    trialEndDate
    trialStartDate
    type
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyQueryVariables,
  APITypes.GetCompanyQuery
>;
export const getCompanyNote = /* GraphQL */ `query GetCompanyNote($id: ID!) {
  getCompanyNote(id: $id) {
    authorName
    companyId
    content
    createdAt
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyNoteQueryVariables,
  APITypes.GetCompanyNoteQuery
>;
export const getCompanyOwner = /* GraphQL */ `query GetCompanyOwner($id: ID!) {
  getCompanyOwner(id: $id) {
    cognitoId
    companyId
    contactPhoneNumber
    createdAt
    discrepancyNotification
    discrepancyNotificationTypes
    domain
    email
    id
    name
    owner
    permissions
    pmNotification
    pmNotificationTypes
    role
    siteAdmin
    subscriptionType
    trainingNotification
    trainingNotificationTypes
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyOwnerQueryVariables,
  APITypes.GetCompanyOwnerQuery
>;
export const getCompanyResource = /* GraphQL */ `query GetCompanyResource($id: ID!) {
  getCompanyResource(id: $id) {
    category
    companyId
    contentFilePath
    contentUrl
    createdAt
    description
    fileType
    folderName
    id
    owner
    title
    trainingTopicId
    updatedAt
    uploadedByUserId
    uploadedByUserName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyResourceQueryVariables,
  APITypes.GetCompanyResourceQuery
>;
export const getDOTInspectionReport = /* GraphQL */ `query GetDOTInspectionReport($id: ID!) {
  getDOTInspectionReport(id: $id) {
    companyId
    complianceStatus
    createdAt
    dotInspectionType
    equipmentCategoryId
    equipmentCategoryName
    expirationDate
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    inspectorCertificationId
    locationId
    okCount
    photos
    regulatoryStandard
    responseData
    signature
    totalItems
    unitId
    unitName
    updatedAt
    userId
    userName
    vehicleLicensePlate
    vehicleVIN
    warnCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDOTInspectionReportQueryVariables,
  APITypes.GetDOTInspectionReportQuery
>;
export const getDailyServiceReport = /* GraphQL */ `query GetDailyServiceReport($id: ID!) {
  getDailyServiceReport(id: $id) {
    companyId
    createdAt
    dailyServiceLogFormId
    equipmentCategoryId
    equipmentCategoryName
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    machineHoursAtService
    okCount
    photos
    responseData
    signature
    totalItems
    umCounterAtService
    unitId
    unitName
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDailyServiceReportQueryVariables,
  APITypes.GetDailyServiceReportQuery
>;
export const getDiscrepancy = /* GraphQL */ `query GetDiscrepancy($id: ID!) {
  getDiscrepancy(id: $id) {
    companyId
    createdAt
    downReason
    equipmentId
    equipmentName
    id
    initialStatus
    log
    owner
    promptDescription
    promptLabel
    promptTitle
    questionIndex
    reportId
    status
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDiscrepancyQueryVariables,
  APITypes.GetDiscrepancyQuery
>;
export const getDocument = /* GraphQL */ `query GetDocument($id: ID!) {
  getDocument(id: $id) {
    assignedSafetyLesson
    contentPath
    createdAt
    folderName
    id
    owner
    resourceLibraryID
    safetyLesson
    sharedWithCompanyIds
    title
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDocumentQueryVariables,
  APITypes.GetDocumentQuery
>;
export const getEquipment = /* GraphQL */ `query GetEquipment($id: ID!) {
  getEquipment(id: $id) {
    companyId
    createdAt
    formId
    id
    image
    name
    units
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEquipmentQueryVariables,
  APITypes.GetEquipmentQuery
>;
export const getEquipmentCategory = /* GraphQL */ `query GetEquipmentCategory($id: ID!) {
  getEquipmentCategory(id: $id) {
    companyId
    createdAt
    formId
    id
    image
    name
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEquipmentCategoryQueryVariables,
  APITypes.GetEquipmentCategoryQuery
>;
export const getErrors = /* GraphQL */ `query GetErrors($id: ID!) {
  getErrors(id: $id) {
    createdAt
    errors
    id
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetErrorsQueryVariables, APITypes.GetErrorsQuery>;
export const getExpenseCategory = /* GraphQL */ `query GetExpenseCategory($id: ID!) {
  getExpenseCategory(id: $id) {
    companyId
    createdAt
    id
    name
    owner
    startingBalance
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExpenseCategoryQueryVariables,
  APITypes.GetExpenseCategoryQuery
>;
export const getExpenseRecord = /* GraphQL */ `query GetExpenseRecord($id: ID!) {
  getExpenseRecord(id: $id) {
    attachments
    companyId
    createdAt
    dateOfInput
    dateOfService
    equipmentCategoryId
    expenseCategories
    id
    invoiceNumber
    laborHoursOT
    laborHoursST
    laborRateOT
    laborRateST
    laborRateScheduleId
    laborRateScheduleName
    owner
    pmExpense
    pmServiceLevelId
    pmServiceLevelName
    totalExpense
    totalLaborCost
    unitId
    updatedAt
    vendorId
    vendorName
    workDescription
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExpenseRecordQueryVariables,
  APITypes.GetExpenseRecordQuery
>;
export const getForm = /* GraphQL */ `query GetForm($id: ID!) {
  getForm(id: $id) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogForm
    equipmentType
    formData
    formType
    id
    inspectionForm
    name
    noMachineHours
    noUMCounter
    owner
    pmServiceScheduleForm
    status
    umCounterLabel
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetFormQueryVariables, APITypes.GetFormQuery>;
export const getFormTemplate = /* GraphQL */ `query GetFormTemplate($id: ID!) {
  getFormTemplate(id: $id) {
    createdAt
    createdByCompanyOwnerId
    dailyServiceLogForm
    formTemplateGroupID
    id
    inspectionForm
    originalCompanyId
    owner
    pmServiceScheduleForm
    templateData
    templateName
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFormTemplateQueryVariables,
  APITypes.GetFormTemplateQuery
>;
export const getFormTemplateGroup = /* GraphQL */ `query GetFormTemplateGroup($id: ID!) {
  getFormTemplateGroup(id: $id) {
    createdAt
    description
    id
    name
    owner
    resourceLibraryID
    sharedWithCompanyIds
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFormTemplateGroupQueryVariables,
  APITypes.GetFormTemplateGroupQuery
>;
export const getHelpSupportDoc = /* GraphQL */ `query GetHelpSupportDoc($id: ID!) {
  getHelpSupportDoc(id: $id) {
    contentFilePath
    contentUrl
    createdAt
    createdByAdminId
    description
    docType
    id
    owner
    sharedWithCompanyIds
    status
    title
    updatedAt
    visibility
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHelpSupportDocQueryVariables,
  APITypes.GetHelpSupportDocQuery
>;
export const getInspectionReport = /* GraphQL */ `query GetInspectionReport($id: ID!) {
  getInspectionReport(id: $id) {
    alwaysTriggerEmail
    companyId
    createdAt
    equipmentCategoryId
    equipmentCategoryName
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    machineHoursAtInspection
    okCount
    photos
    responseData
    signature
    totalItems
    umCounterAtInspection
    unitId
    unitName
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInspectionReportQueryVariables,
  APITypes.GetInspectionReportQuery
>;
export const getInvoice = /* GraphQL */ `query GetInvoice($id: ID!) {
  getInvoice(id: $id) {
    amount
    companyId
    createdAt
    date
    description
    id
    invoiceNumber
    lineItems
    owner
    pdfUrl
    status
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetInvoiceQueryVariables,
  APITypes.GetInvoiceQuery
>;
export const getLaborCategory = /* GraphQL */ `query GetLaborCategory($id: ID!) {
  getLaborCategory(id: $id) {
    companyId
    createdAt
    id
    isActive
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLaborCategoryQueryVariables,
  APITypes.GetLaborCategoryQuery
>;
export const getLaborRate = /* GraphQL */ `query GetLaborRate($id: ID!) {
  getLaborRate(id: $id) {
    categoryId
    createdAt
    effectiveDate
    id
    overtimeRate
    owner
    standardRate
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLaborRateQueryVariables,
  APITypes.GetLaborRateQuery
>;
export const getLibraryPlanTemplate = /* GraphQL */ `query GetLibraryPlanTemplate($id: ID!) {
  getLibraryPlanTemplate(id: $id) {
    categories
    categoryCount
    createdAt
    createdByAdminId
    createdByAdminName
    cycleDuration
    description
    governingStandard
    id
    minimumTimeRequired
    name
    owner
    sharedWithCompanyIds
    status
    topicCount
    updatedAt
    workingDays
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLibraryPlanTemplateQueryVariables,
  APITypes.GetLibraryPlanTemplateQuery
>;
export const getLibraryTopicTemplate = /* GraphQL */ `query GetLibraryTopicTemplate($id: ID!) {
  getLibraryTopicTemplate(id: $id) {
    contentFilePath
    contentUrl
    createdAt
    createdByAdminId
    description
    id
    owner
    style
    timeValue
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLibraryTopicTemplateQueryVariables,
  APITypes.GetLibraryTopicTemplateQuery
>;
export const getLocation = /* GraphQL */ `query GetLocation($id: ID!) {
  getLocation(id: $id) {
    companyId
    createdAt
    description
    id
    name
    owner
    regionalDivisionId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLocationQueryVariables,
  APITypes.GetLocationQuery
>;
export const getModuleSubscription = /* GraphQL */ `query GetModuleSubscription($id: ID!) {
  getModuleSubscription(id: $id) {
    activatedAt
    cancelRequestedAt
    companyId
    createdAt
    effectiveEndDate
    id
    moduleKey
    monthlyRate
    owner
    pricingModel
    status
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetModuleSubscriptionQueryVariables,
  APITypes.GetModuleSubscriptionQuery
>;
export const getPMConfiguration = /* GraphQL */ `query GetPMConfiguration($id: ID!) {
  getPMConfiguration(id: $id) {
    companyId
    createdAt
    dueSoonPercentage
    id
    laborCategoryId
    owner
    unitId
    unitOfMeasure
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPMConfigurationQueryVariables,
  APITypes.GetPMConfigurationQuery
>;
export const getPMModuleContent = /* GraphQL */ `query GetPMModuleContent($id: ID!) {
  getPMModuleContent(id: $id) {
    createdAt
    id
    owner
    pmServiceFormId
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPMModuleContentQueryVariables,
  APITypes.GetPMModuleContentQuery
>;
export const getPMNotificationSetting = /* GraphQL */ `query GetPMNotificationSetting($id: ID!) {
  getPMNotificationSetting(id: $id) {
    createdAt
    emailThresholdUM
    id
    lastNotificationSent
    notificationFrequency
    owner
    pmConfigurationId
    recipients
    serviceLevelId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPMNotificationSettingQueryVariables,
  APITypes.GetPMNotificationSettingQuery
>;
export const getPMPartsAndProcedure = /* GraphQL */ `query GetPMPartsAndProcedure($id: ID!) {
  getPMPartsAndProcedure(id: $id) {
    category
    companyId
    createdAt
    createdByUserId
    createdByUserName
    id
    itemName
    itemType
    manufacturer
    owner
    partNumber
    pmConfigurationId
    pmConfigurationIds
    price
    quantity
    sortOrder
    unitOfMeasure
    updatedAt
    vendorId
    vendorName
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPMPartsAndProcedureQueryVariables,
  APITypes.GetPMPartsAndProcedureQuery
>;
export const getPMReport = /* GraphQL */ `query GetPMReport($id: ID!) {
  getPMReport(id: $id) {
    actualUM
    companyId
    createdAt
    id
    issueDescription
    issueTicketCreated
    issueTicketId
    laborHoursOT
    laborHoursST
    laborRateOT
    laborRateST
    laborRateScheduleId
    laborRateScheduleName
    owner
    photos
    pmConfigurationId
    reportData
    serviceDate
    serviceLevelId
    serviceLevelName
    signature
    status
    technicianId
    technicianName
    totalLaborCost
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPMReportQueryVariables,
  APITypes.GetPMReportQuery
>;
export const getPMServiceLevel = /* GraphQL */ `query GetPMServiceLevel($id: ID!) {
  getPMServiceLevel(id: $id) {
    createdAt
    description
    id
    intervalValue
    lastServiceDate
    lastServiceUM
    levelIdentifier
    owner
    pmConfigurationId
    pmServiceFormId
    serviceLevelAssignments
    targetUM
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPMServiceLevelQueryVariables,
  APITypes.GetPMServiceLevelQuery
>;
export const getRegionalDivision = /* GraphQL */ `query GetRegionalDivision($id: ID!) {
  getRegionalDivision(id: $id) {
    companyId
    createdAt
    description
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRegionalDivisionQueryVariables,
  APITypes.GetRegionalDivisionQuery
>;
export const getReport = /* GraphQL */ `query GetReport($id: ID!) {
  getReport(id: $id) {
    alwaysTriggerEmail
    companyId
    createdAt
    dailyServiceLogReport
    equipmentId
    equipmentLocationId
    equipmentName
    id
    inspectionCompleted
    inspectionStarted
    name
    signature
    unitId
    unitName
    updatedAt
    userData
    userId
    userLocation
    __typename
  }
}
` as GeneratedQuery<APITypes.GetReportQueryVariables, APITypes.GetReportQuery>;
export const getReportAnswer = /* GraphQL */ `query GetReportAnswer($id: ID!) {
  getReportAnswer(id: $id) {
    companyId
    createdAt
    id
    notes
    parentReportId
    photos
    promptDescription
    promptKey
    promptLabel
    promptTitle
    promptType
    reportType
    sortOrder
    unitId
    updatedAt
    value
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReportAnswerQueryVariables,
  APITypes.GetReportAnswerQuery
>;
export const getResourceLibrary = /* GraphQL */ `query GetResourceLibrary($id: ID!) {
  getResourceLibrary(id: $id) {
    companyOwnerId
    createdAt
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetResourceLibraryQueryVariables,
  APITypes.GetResourceLibraryQuery
>;
export const getSavedReportConfiguration = /* GraphQL */ `query GetSavedReportConfiguration($id: ID!) {
  getSavedReportConfiguration(id: $id) {
    companyId
    compareDateRangeEnd
    compareDateRangeStart
    createdAt
    dateRangeEnd
    dateRangeStart
    dateRangeType
    filtersJson
    groupByField
    id
    lastRunAt
    metricCategory
    metricKey
    reportName
    updatedAt
    userId
    visualizationType
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSavedReportConfigurationQueryVariables,
  APITypes.GetSavedReportConfigurationQuery
>;
export const getSensitiveUserInfo = /* GraphQL */ `query GetSensitiveUserInfo($id: ID!) {
  getSensitiveUserInfo(id: $id) {
    cognitoId
    companyId
    createdAt
    dateOfBirth
    driversLicenseClass
    driversLicenseExpirationDate
    driversLicenseNumber
    driversLicenseState
    emergencyContactName
    emergencyContactPhoneNumber
    emergencyContactRelationship
    id
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSensitiveUserInfoQueryVariables,
  APITypes.GetSensitiveUserInfoQuery
>;
export const getShiftReport = /* GraphQL */ `query GetShiftReport($id: ID!) {
  getShiftReport(id: $id) {
    alwaysTriggerEmail
    companyId
    createdAt
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    locationId
    locationName
    okCount
    photos
    responseData
    shiftType
    signature
    totalItems
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetShiftReportQueryVariables,
  APITypes.GetShiftReportQuery
>;
export const getSingleUnit = /* GraphQL */ `query GetSingleUnit($id: ID!) {
  getSingleUnit(id: $id) {
    annualProjectedUsage
    aquisitionCost
    aquisitionDate
    assignedTo
    axleConfiguration
    categoryId
    costTrackingModuleEnrollment
    createdAt
    currentMachineHours
    currentUMCounterValue
    dailyServiceLogFormId
    description
    dispositionDate
    dispositionReason
    downReason
    engineManufacturer
    engineModelNumber
    equipmentStatus
    extraUnitInfo
    id
    image
    inputByPerson
    inputDate
    lastDailyServiceDate
    lastInspectionDate
    lastServiceHours
    licenseNumber
    locationId
    machineHoursAtAquisition
    machineUMCounterAtAquisition
    manufactureDate
    manufacturerName
    modelNumber
    name
    pmModuleEnrollment
    putInServiceDate
    removedFromServiceDate
    removedFromServiceReason
    replacedUMCounterHistory
    replacedUMCounterStatus
    replacedUMCounterValue
    serialNumber
    tiresModuleEnrollment
    unitOfMeasure
    updatedAt
    utilizationAdjustmentDays
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSingleUnitQueryVariables,
  APITypes.GetSingleUnitQuery
>;
export const getSkillAssignment = /* GraphQL */ `query GetSkillAssignment($id: ID!) {
  getSkillAssignment(id: $id) {
    companyId
    createdAt
    evaluatedBy
    evaluatedByName
    evaluationDate
    id
    owner
    skillLevel
    subCategoryId
    taskId
    updatedAt
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillAssignmentQueryVariables,
  APITypes.GetSkillAssignmentQuery
>;
export const getSkillCategory = /* GraphQL */ `query GetSkillCategory($id: ID!) {
  getSkillCategory(id: $id) {
    allowMachineNumber
    classificationId
    companyId
    createdAt
    equipmentCategoryId
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillCategoryQueryVariables,
  APITypes.GetSkillCategoryQuery
>;
export const getSkillLevel = /* GraphQL */ `query GetSkillLevel($id: ID!) {
  getSkillLevel(id: $id) {
    color
    companyId
    createdAt
    description
    id
    name
    owner
    sortOrder
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillLevelQueryVariables,
  APITypes.GetSkillLevelQuery
>;
export const getSkillTask = /* GraphQL */ `query GetSkillTask($id: ID!) {
  getSkillTask(id: $id) {
    categoryId
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSkillTaskQueryVariables,
  APITypes.GetSkillTaskQuery
>;
export const getSubCategory = /* GraphQL */ `query GetSubCategory($id: ID!) {
  getSubCategory(id: $id) {
    categoryId
    companyId
    createdAt
    id
    name
    owner
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSubCategoryQueryVariables,
  APITypes.GetSubCategoryQuery
>;
export const getTire = /* GraphQL */ `query GetTire($id: ID!) {
  getTire(id: $id) {
    assignedAxle
    assignedPosition
    companyId
    createdAt
    currentTirePressure
    currentTreadDepth
    dateInstalled
    dateUninstalled
    failureReason
    id
    inflationMedium
    loadRating
    loadRatingUnit
    minimumTreadDepth
    name
    owner
    recommendedTirePressure
    removedFromService
    removedFromServiceDate
    tireCategory
    tireManufacturer
    tireModel
    tireSize
    tireStatus
    treadDepthAtInstall
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetTireQueryVariables, APITypes.GetTireQuery>;
export const getTireReport = /* GraphQL */ `query GetTireReport($id: ID!) {
  getTireReport(id: $id) {
    alwaysTriggerEmail
    companyId
    createdAt
    equipmentCategoryId
    equipmentCategoryName
    equipmentLocationId
    id
    inspectionCompleted
    inspectionStarted
    name
    signature
    tireId
    unitId
    unitName
    updatedAt
    userData
    userId
    userLocation
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTireReportQueryVariables,
  APITypes.GetTireReportQuery
>;
export const getTrainingAffidavit = /* GraphQL */ `query GetTrainingAffidavit($id: ID!) {
  getTrainingAffidavit(id: $id) {
    adminId
    affidavitDate
    companyId
    createdAt
    id
    legalText
    nextDueDate
    owner
    planId
    signaturePath
    updatedAt
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrainingAffidavitQueryVariables,
  APITypes.GetTrainingAffidavitQuery
>;
export const getTrainingCompletion = /* GraphQL */ `query GetTrainingCompletion($id: ID!) {
  getTrainingCompletion(id: $id) {
    categoryId
    companyId
    completionDate
    createdAt
    id
    launched
    markedAsViewed
    owner
    planId
    scheduleDate
    signaturePath
    timeValueMinutes
    topicId
    updatedAt
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrainingCompletionQueryVariables,
  APITypes.GetTrainingCompletionQuery
>;
export const getTrainingEnrollment = /* GraphQL */ `query GetTrainingEnrollment($id: ID!) {
  getTrainingEnrollment(id: $id) {
    companyId
    createdAt
    enrolledDate
    id
    lastCompletionDate
    nextDueDate
    owner
    planId
    status
    updatedAt
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrainingEnrollmentQueryVariables,
  APITypes.GetTrainingEnrollmentQuery
>;
export const getTrainingPlan = /* GraphQL */ `query GetTrainingPlan($id: ID!) {
  getTrainingPlan(id: $id) {
    categories
    companyId
    createdAt
    cycleDuration
    governingStandard
    holidays
    id
    minimumTimeRequired
    name
    owner
    startDate
    status
    updatedAt
    workingDays
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrainingPlanQueryVariables,
  APITypes.GetTrainingPlanQuery
>;
export const getTrainingQuizResponse = /* GraphQL */ `query GetTrainingQuizResponse($id: ID!) {
  getTrainingQuizResponse(id: $id) {
    attemptNumber
    categoryId
    companyId
    completedAt
    createdAt
    cycleStartDate
    formId
    id
    owner
    passed
    planId
    responseData
    score
    signaturePath
    totalQuestions
    updatedAt
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrainingQuizResponseQueryVariables,
  APITypes.GetTrainingQuizResponseQuery
>;
export const getTrainingSchedule = /* GraphQL */ `query GetTrainingSchedule($id: ID!) {
  getTrainingSchedule(id: $id) {
    assignedUserId
    categoryId
    companyId
    createdAt
    dayNumber
    id
    locked
    owner
    planId
    scheduledDate
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrainingScheduleQueryVariables,
  APITypes.GetTrainingScheduleQuery
>;
export const getTrainingTopic = /* GraphQL */ `query GetTrainingTopic($id: ID!) {
  getTrainingTopic(id: $id) {
    categoryIds
    companyId
    companyResourceId
    contentFilePath
    contentUrl
    createdAt
    description
    id
    owner
    planIds
    style
    timeValue
    topicId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTrainingTopicQueryVariables,
  APITypes.GetTrainingTopicQuery
>;
export const getUnitExpenseBudget = /* GraphQL */ `query GetUnitExpenseBudget($id: ID!) {
  getUnitExpenseBudget(id: $id) {
    companyId
    createdAt
    expenseCategoryId
    id
    owner
    startingBalance
    unitId
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUnitExpenseBudgetQueryVariables,
  APITypes.GetUnitExpenseBudgetQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    archived
    cognitoId
    companyId
    contactPhoneNumber
    contactPhoneType
    createdAt
    currentJobClassification
    dateOfHire
    discrepancyNotification
    discrepancyNotificationTypes
    domain
    driversLicenseStatus
    email
    globalLocationPermission
    id
    inputByPerson
    inputDate
    locationAssignment
    name
    notesAboutUser
    onHighwayEligibility
    owner
    permissions
    personalIdentification
    pmNotification
    pmNotificationTypes
    position
    regionalAssignment
    role
    safetyLessons
    skillTrackingModuleEnrollment
    trainingModuleEnrollment
    trainingNotification
    trainingNotificationTypes
    updatedAt
    userPhoto
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const getUserFile = /* GraphQL */ `query GetUserFile($id: ID!) {
  getUserFile(id: $id) {
    companyId
    createdAt
    fileName
    fileSize
    id
    owner
    s3Path
    updatedAt
    uploadedAt
    uploadedBy
    uploadedByName
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserFileQueryVariables,
  APITypes.GetUserFileQuery
>;
export const getUserReportFavorite = /* GraphQL */ `query GetUserReportFavorite($id: ID!) {
  getUserReportFavorite(id: $id) {
    companyId
    createdAt
    id
    reportTypeKey
    updatedAt
    userId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserReportFavoriteQueryVariables,
  APITypes.GetUserReportFavoriteQuery
>;
export const getUserSkillReport = /* GraphQL */ `query GetUserSkillReport($id: ID!) {
  getUserSkillReport(id: $id) {
    assessorId
    assessorName
    companyId
    createdAt
    expirationDate
    formId
    gpsLatitude
    gpsLocationType
    gpsLongitude
    id
    inopCount
    inspectionCompleted
    inspectionDurationSeconds
    inspectionStarted
    okCount
    passFailStatus
    photos
    qualificationLevel
    responseData
    signature
    skillCategory
    skillName
    totalItems
    updatedAt
    userId
    userName
    warnCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserSkillReportQueryVariables,
  APITypes.GetUserSkillReportQuery
>;
export const getVendorList = /* GraphQL */ `query GetVendorList($id: ID!) {
  getVendorList(id: $id) {
    address
    companyId
    createdAt
    faxNumber
    id
    name
    owner
    phoneNumber
    repName
    repPhoneNumber
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVendorListQueryVariables,
  APITypes.GetVendorListQuery
>;
export const getVideo = /* GraphQL */ `query GetVideo($id: ID!) {
  getVideo(id: $id) {
    assignedSafetyLesson
    contentPath
    createdAt
    folderName
    id
    owner
    resourceLibraryID
    safetyLesson
    sharedWithCompanyIds
    title
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetVideoQueryVariables, APITypes.GetVideoQuery>;
export const listArchivedDiscrepancies = /* GraphQL */ `query ListArchivedDiscrepancies(
  $filter: ModelArchivedDiscrepancyFilterInput
  $limit: Int
  $nextToken: String
) {
  listArchivedDiscrepancies(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      archivedDate
      companyId
      createdAt
      downReason
      equipmentId
      equipmentName
      id
      initialStatus
      log
      owner
      promptDescription
      promptLabel
      promptTitle
      questionIndex
      reportId
      status
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListArchivedDiscrepanciesQueryVariables,
  APITypes.ListArchivedDiscrepanciesQuery
>;
export const listArchivedDiscrepancyByCompanyIdAndUpdatedAt = /* GraphQL */ `query ListArchivedDiscrepancyByCompanyIdAndUpdatedAt(
  $companyId: String!
  $filter: ModelArchivedDiscrepancyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $updatedAt: ModelStringKeyConditionInput
) {
  listArchivedDiscrepancyByCompanyIdAndUpdatedAt(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    updatedAt: $updatedAt
  ) {
    items {
      archivedDate
      companyId
      createdAt
      downReason
      equipmentId
      equipmentName
      id
      initialStatus
      log
      owner
      promptDescription
      promptLabel
      promptTitle
      questionIndex
      reportId
      status
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListArchivedDiscrepancyByCompanyIdAndUpdatedAtQueryVariables,
  APITypes.ListArchivedDiscrepancyByCompanyIdAndUpdatedAtQuery
>;
export const listArchivedDiscrepancyByEquipmentIdAndUpdatedAt = /* GraphQL */ `query ListArchivedDiscrepancyByEquipmentIdAndUpdatedAt(
  $equipmentId: String!
  $filter: ModelArchivedDiscrepancyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $updatedAt: ModelStringKeyConditionInput
) {
  listArchivedDiscrepancyByEquipmentIdAndUpdatedAt(
    equipmentId: $equipmentId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    updatedAt: $updatedAt
  ) {
    items {
      archivedDate
      companyId
      createdAt
      downReason
      equipmentId
      equipmentName
      id
      initialStatus
      log
      owner
      promptDescription
      promptLabel
      promptTitle
      questionIndex
      reportId
      status
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListArchivedDiscrepancyByEquipmentIdAndUpdatedAtQueryVariables,
  APITypes.ListArchivedDiscrepancyByEquipmentIdAndUpdatedAtQuery
>;
export const listArchivedDiscrepancyByUnitIdAndUpdatedAt = /* GraphQL */ `query ListArchivedDiscrepancyByUnitIdAndUpdatedAt(
  $filter: ModelArchivedDiscrepancyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
  $updatedAt: ModelStringKeyConditionInput
) {
  listArchivedDiscrepancyByUnitIdAndUpdatedAt(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
    updatedAt: $updatedAt
  ) {
    items {
      archivedDate
      companyId
      createdAt
      downReason
      equipmentId
      equipmentName
      id
      initialStatus
      log
      owner
      promptDescription
      promptLabel
      promptTitle
      questionIndex
      reportId
      status
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListArchivedDiscrepancyByUnitIdAndUpdatedAtQueryVariables,
  APITypes.ListArchivedDiscrepancyByUnitIdAndUpdatedAtQuery
>;
export const listAuditLogByCompanyIdAndCreatedAt = /* GraphQL */ `query ListAuditLogByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelAuditLogFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAuditLogByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      action
      companyId
      createdAt
      details
      id
      resourceId
      resourceName
      resourceType
      ttl
      updatedAt
      userId
      userName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAuditLogByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListAuditLogByCompanyIdAndCreatedAtQuery
>;
export const listAuditLogs = /* GraphQL */ `query ListAuditLogs(
  $filter: ModelAuditLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listAuditLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      action
      companyId
      createdAt
      details
      id
      resourceId
      resourceName
      resourceType
      ttl
      updatedAt
      userId
      userName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAuditLogsQueryVariables,
  APITypes.ListAuditLogsQuery
>;
export const listAxleBlueprints = /* GraphQL */ `query ListAxleBlueprints(
  $filter: ModelAxleBlueprintFilterInput
  $limit: Int
  $nextToken: String
) {
  listAxleBlueprints(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      axles
      centerlineLength
      companyId
      createdAt
      description
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAxleBlueprintsQueryVariables,
  APITypes.ListAxleBlueprintsQuery
>;
export const listBillingRateByCompanyId = /* GraphQL */ `query ListBillingRateByCompanyId(
  $companyId: String!
  $filter: ModelBillingRateFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBillingRateByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      id
      owner
      ratePerCostTracking
      ratePerEquipment
      ratePerPM
      ratePerSafetyEnrollment
      ratePerSkillQualification
      ratePerTireMaint
      ratePerUser
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBillingRateByCompanyIdQueryVariables,
  APITypes.ListBillingRateByCompanyIdQuery
>;
export const listBillingRates = /* GraphQL */ `query ListBillingRates(
  $filter: ModelBillingRateFilterInput
  $limit: Int
  $nextToken: String
) {
  listBillingRates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      id
      owner
      ratePerCostTracking
      ratePerEquipment
      ratePerPM
      ratePerSafetyEnrollment
      ratePerSkillQualification
      ratePerTireMaint
      ratePerUser
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBillingRatesQueryVariables,
  APITypes.ListBillingRatesQuery
>;
export const listBusinessAdmins = /* GraphQL */ `query ListBusinessAdmins(
  $filter: ModelBusinessAdminFilterInput
  $limit: Int
  $nextToken: String
) {
  listBusinessAdmins(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      cognitoId
      createdAt
      domain
      email
      id
      name
      owner
      permissions
      role
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBusinessAdminsQueryVariables,
  APITypes.ListBusinessAdminsQuery
>;
export const listChangeLogEntries = /* GraphQL */ `query ListChangeLogEntries(
  $filter: ModelChangeLogEntryFilterInput
  $limit: Int
  $nextToken: String
) {
  listChangeLogEntries(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      changedBy
      changedByName
      companyId
      createdAt
      description
      fieldName
      id
      newValue
      oldValue
      owner
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListChangeLogEntriesQueryVariables,
  APITypes.ListChangeLogEntriesQuery
>;
export const listClassifications = /* GraphQL */ `query ListClassifications(
  $filter: ModelClassificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listClassifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClassificationsQueryVariables,
  APITypes.ListClassificationsQuery
>;
export const listCompanies = /* GraphQL */ `query ListCompanies(
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      accountNumber
      accountOrigin
      accountStatus
      addOnGracePeriodEndDate
      archived
      assignedRep
      billingAnchorDay
      billingContactAddress
      billingContactEmail
      billingContactName
      billingContactPhone
      billingCycle
      businessType
      cancelEffectiveDate
      cancelReason
      cancelReasonNote
      cancelRequestedAt
      companyOwnerId
      coreMonthlyRate
      costTrackingModuleEnrollment
      createdAt
      dataRetentionEndDate
      description
      gracePeriodEndDate
      id
      industryNAICS
      industrySIC
      initialContactDate
      initialStarterPackageEnrollment
      logo
      maxNumberEquipment
      maxNumberUsers
      name
      nextBillingDate
      notes
      numberOfUsers
      paidStartDate
      paymentFailedAt
      paymentMethod
      pmModuleEnrollment
      primaryContactEmail
      primaryContactName
      primaryContactPhone
      primaryContactPosition
      primaryLocation
      referredBy
      retryAttempts
      safetyComplianceStandard
      secondaryContactEmail
      secondaryContactName
      secondaryContactPhone
      secondaryContactPosition
      skillTrackingModuleEnrollment
      starterPackage
      status
      subscriptionExpiration
      subscriptionType
      tiresModuleEnrollment
      trainingModuleEnrollment
      trialEndDate
      trialStartDate
      type
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompaniesQueryVariables,
  APITypes.ListCompaniesQuery
>;
export const listCompanyByCompanyOwnerId = /* GraphQL */ `query ListCompanyByCompanyOwnerId(
  $companyOwnerId: String!
  $filter: ModelCompanyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCompanyByCompanyOwnerId(
    companyOwnerId: $companyOwnerId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      accountNumber
      accountOrigin
      accountStatus
      addOnGracePeriodEndDate
      archived
      assignedRep
      billingAnchorDay
      billingContactAddress
      billingContactEmail
      billingContactName
      billingContactPhone
      billingCycle
      businessType
      cancelEffectiveDate
      cancelReason
      cancelReasonNote
      cancelRequestedAt
      companyOwnerId
      coreMonthlyRate
      costTrackingModuleEnrollment
      createdAt
      dataRetentionEndDate
      description
      gracePeriodEndDate
      id
      industryNAICS
      industrySIC
      initialContactDate
      initialStarterPackageEnrollment
      logo
      maxNumberEquipment
      maxNumberUsers
      name
      nextBillingDate
      notes
      numberOfUsers
      paidStartDate
      paymentFailedAt
      paymentMethod
      pmModuleEnrollment
      primaryContactEmail
      primaryContactName
      primaryContactPhone
      primaryContactPosition
      primaryLocation
      referredBy
      retryAttempts
      safetyComplianceStandard
      secondaryContactEmail
      secondaryContactName
      secondaryContactPhone
      secondaryContactPosition
      skillTrackingModuleEnrollment
      starterPackage
      status
      subscriptionExpiration
      subscriptionType
      tiresModuleEnrollment
      trainingModuleEnrollment
      trialEndDate
      trialStartDate
      type
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyByCompanyOwnerIdQueryVariables,
  APITypes.ListCompanyByCompanyOwnerIdQuery
>;
export const listCompanyNoteByCompanyIdAndCreatedAt = /* GraphQL */ `query ListCompanyNoteByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelCompanyNoteFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCompanyNoteByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      authorName
      companyId
      content
      createdAt
      id
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyNoteByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListCompanyNoteByCompanyIdAndCreatedAtQuery
>;
export const listCompanyNotes = /* GraphQL */ `query ListCompanyNotes(
  $filter: ModelCompanyNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanyNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      authorName
      companyId
      content
      createdAt
      id
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyNotesQueryVariables,
  APITypes.ListCompanyNotesQuery
>;
export const listCompanyOwnerByCompanyId = /* GraphQL */ `query ListCompanyOwnerByCompanyId(
  $companyId: String!
  $filter: ModelCompanyOwnerFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCompanyOwnerByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      cognitoId
      companyId
      contactPhoneNumber
      createdAt
      discrepancyNotification
      discrepancyNotificationTypes
      domain
      email
      id
      name
      owner
      permissions
      pmNotification
      pmNotificationTypes
      role
      siteAdmin
      subscriptionType
      trainingNotification
      trainingNotificationTypes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyOwnerByCompanyIdQueryVariables,
  APITypes.ListCompanyOwnerByCompanyIdQuery
>;
export const listCompanyOwners = /* GraphQL */ `query ListCompanyOwners(
  $filter: ModelCompanyOwnerFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanyOwners(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      cognitoId
      companyId
      contactPhoneNumber
      createdAt
      discrepancyNotification
      discrepancyNotificationTypes
      domain
      email
      id
      name
      owner
      permissions
      pmNotification
      pmNotificationTypes
      role
      siteAdmin
      subscriptionType
      trainingNotification
      trainingNotificationTypes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyOwnersQueryVariables,
  APITypes.ListCompanyOwnersQuery
>;
export const listCompanyResourceByCompanyId = /* GraphQL */ `query ListCompanyResourceByCompanyId(
  $companyId: String!
  $filter: ModelCompanyResourceFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCompanyResourceByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      category
      companyId
      contentFilePath
      contentUrl
      createdAt
      description
      fileType
      folderName
      id
      owner
      title
      trainingTopicId
      updatedAt
      uploadedByUserId
      uploadedByUserName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyResourceByCompanyIdQueryVariables,
  APITypes.ListCompanyResourceByCompanyIdQuery
>;
export const listCompanyResources = /* GraphQL */ `query ListCompanyResources(
  $filter: ModelCompanyResourceFilterInput
  $limit: Int
  $nextToken: String
) {
  listCompanyResources(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      category
      companyId
      contentFilePath
      contentUrl
      createdAt
      description
      fileType
      folderName
      id
      owner
      title
      trainingTopicId
      updatedAt
      uploadedByUserId
      uploadedByUserName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompanyResourcesQueryVariables,
  APITypes.ListCompanyResourcesQuery
>;
export const listDOTInspectionReportByCompanyIdAndCreatedAt = /* GraphQL */ `query ListDOTInspectionReportByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelDOTInspectionReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDOTInspectionReportByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      complianceStatus
      createdAt
      dotInspectionType
      equipmentCategoryId
      equipmentCategoryName
      expirationDate
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      inspectorCertificationId
      locationId
      okCount
      photos
      regulatoryStandard
      responseData
      signature
      totalItems
      unitId
      unitName
      updatedAt
      userId
      userName
      vehicleLicensePlate
      vehicleVIN
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDOTInspectionReportByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListDOTInspectionReportByCompanyIdAndCreatedAtQuery
>;
export const listDOTInspectionReportByEquipmentCategoryIdAndCreatedAt = /* GraphQL */ `query ListDOTInspectionReportByEquipmentCategoryIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $equipmentCategoryId: String!
  $filter: ModelDOTInspectionReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDOTInspectionReportByEquipmentCategoryIdAndCreatedAt(
    createdAt: $createdAt
    equipmentCategoryId: $equipmentCategoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      complianceStatus
      createdAt
      dotInspectionType
      equipmentCategoryId
      equipmentCategoryName
      expirationDate
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      inspectorCertificationId
      locationId
      okCount
      photos
      regulatoryStandard
      responseData
      signature
      totalItems
      unitId
      unitName
      updatedAt
      userId
      userName
      vehicleLicensePlate
      vehicleVIN
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDOTInspectionReportByEquipmentCategoryIdAndCreatedAtQueryVariables,
  APITypes.ListDOTInspectionReportByEquipmentCategoryIdAndCreatedAtQuery
>;
export const listDOTInspectionReportByUnitIdAndCreatedAt = /* GraphQL */ `query ListDOTInspectionReportByUnitIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelDOTInspectionReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listDOTInspectionReportByUnitIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      companyId
      complianceStatus
      createdAt
      dotInspectionType
      equipmentCategoryId
      equipmentCategoryName
      expirationDate
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      inspectorCertificationId
      locationId
      okCount
      photos
      regulatoryStandard
      responseData
      signature
      totalItems
      unitId
      unitName
      updatedAt
      userId
      userName
      vehicleLicensePlate
      vehicleVIN
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDOTInspectionReportByUnitIdAndCreatedAtQueryVariables,
  APITypes.ListDOTInspectionReportByUnitIdAndCreatedAtQuery
>;
export const listDOTInspectionReportByUserIdAndCreatedAt = /* GraphQL */ `query ListDOTInspectionReportByUserIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelDOTInspectionReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listDOTInspectionReportByUserIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      companyId
      complianceStatus
      createdAt
      dotInspectionType
      equipmentCategoryId
      equipmentCategoryName
      expirationDate
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      inspectorCertificationId
      locationId
      okCount
      photos
      regulatoryStandard
      responseData
      signature
      totalItems
      unitId
      unitName
      updatedAt
      userId
      userName
      vehicleLicensePlate
      vehicleVIN
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDOTInspectionReportByUserIdAndCreatedAtQueryVariables,
  APITypes.ListDOTInspectionReportByUserIdAndCreatedAtQuery
>;
export const listDOTInspectionReports = /* GraphQL */ `query ListDOTInspectionReports(
  $filter: ModelDOTInspectionReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listDOTInspectionReports(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyId
      complianceStatus
      createdAt
      dotInspectionType
      equipmentCategoryId
      equipmentCategoryName
      expirationDate
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      inspectorCertificationId
      locationId
      okCount
      photos
      regulatoryStandard
      responseData
      signature
      totalItems
      unitId
      unitName
      updatedAt
      userId
      userName
      vehicleLicensePlate
      vehicleVIN
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDOTInspectionReportsQueryVariables,
  APITypes.ListDOTInspectionReportsQuery
>;
export const listDailyServiceReportByCompanyIdAndCreatedAt = /* GraphQL */ `query ListDailyServiceReportByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelDailyServiceReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDailyServiceReportByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      dailyServiceLogFormId
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtService
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtService
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDailyServiceReportByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListDailyServiceReportByCompanyIdAndCreatedAtQuery
>;
export const listDailyServiceReportByEquipmentCategoryIdAndCreatedAt = /* GraphQL */ `query ListDailyServiceReportByEquipmentCategoryIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $equipmentCategoryId: String!
  $filter: ModelDailyServiceReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDailyServiceReportByEquipmentCategoryIdAndCreatedAt(
    createdAt: $createdAt
    equipmentCategoryId: $equipmentCategoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      dailyServiceLogFormId
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtService
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtService
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDailyServiceReportByEquipmentCategoryIdAndCreatedAtQueryVariables,
  APITypes.ListDailyServiceReportByEquipmentCategoryIdAndCreatedAtQuery
>;
export const listDailyServiceReportByUnitIdAndCreatedAt = /* GraphQL */ `query ListDailyServiceReportByUnitIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelDailyServiceReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listDailyServiceReportByUnitIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      companyId
      createdAt
      dailyServiceLogFormId
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtService
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtService
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDailyServiceReportByUnitIdAndCreatedAtQueryVariables,
  APITypes.ListDailyServiceReportByUnitIdAndCreatedAtQuery
>;
export const listDailyServiceReportByUserIdAndCreatedAt = /* GraphQL */ `query ListDailyServiceReportByUserIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelDailyServiceReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listDailyServiceReportByUserIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      companyId
      createdAt
      dailyServiceLogFormId
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtService
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtService
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDailyServiceReportByUserIdAndCreatedAtQueryVariables,
  APITypes.ListDailyServiceReportByUserIdAndCreatedAtQuery
>;
export const listDailyServiceReports = /* GraphQL */ `query ListDailyServiceReports(
  $filter: ModelDailyServiceReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listDailyServiceReports(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyId
      createdAt
      dailyServiceLogFormId
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtService
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtService
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDailyServiceReportsQueryVariables,
  APITypes.ListDailyServiceReportsQuery
>;
export const listDiscrepancies = /* GraphQL */ `query ListDiscrepancies(
  $filter: ModelDiscrepancyFilterInput
  $limit: Int
  $nextToken: String
) {
  listDiscrepancies(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      downReason
      equipmentId
      equipmentName
      id
      initialStatus
      log
      owner
      promptDescription
      promptLabel
      promptTitle
      questionIndex
      reportId
      status
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDiscrepanciesQueryVariables,
  APITypes.ListDiscrepanciesQuery
>;
export const listDiscrepancyByCompanyIdAndUpdatedAt = /* GraphQL */ `query ListDiscrepancyByCompanyIdAndUpdatedAt(
  $companyId: String!
  $filter: ModelDiscrepancyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $updatedAt: ModelStringKeyConditionInput
) {
  listDiscrepancyByCompanyIdAndUpdatedAt(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    updatedAt: $updatedAt
  ) {
    items {
      companyId
      createdAt
      downReason
      equipmentId
      equipmentName
      id
      initialStatus
      log
      owner
      promptDescription
      promptLabel
      promptTitle
      questionIndex
      reportId
      status
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDiscrepancyByCompanyIdAndUpdatedAtQueryVariables,
  APITypes.ListDiscrepancyByCompanyIdAndUpdatedAtQuery
>;
export const listDiscrepancyByEquipmentIdAndUpdatedAt = /* GraphQL */ `query ListDiscrepancyByEquipmentIdAndUpdatedAt(
  $equipmentId: String!
  $filter: ModelDiscrepancyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $updatedAt: ModelStringKeyConditionInput
) {
  listDiscrepancyByEquipmentIdAndUpdatedAt(
    equipmentId: $equipmentId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    updatedAt: $updatedAt
  ) {
    items {
      companyId
      createdAt
      downReason
      equipmentId
      equipmentName
      id
      initialStatus
      log
      owner
      promptDescription
      promptLabel
      promptTitle
      questionIndex
      reportId
      status
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDiscrepancyByEquipmentIdAndUpdatedAtQueryVariables,
  APITypes.ListDiscrepancyByEquipmentIdAndUpdatedAtQuery
>;
export const listDiscrepancyByUnitIdAndUpdatedAt = /* GraphQL */ `query ListDiscrepancyByUnitIdAndUpdatedAt(
  $filter: ModelDiscrepancyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
  $updatedAt: ModelStringKeyConditionInput
) {
  listDiscrepancyByUnitIdAndUpdatedAt(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
    updatedAt: $updatedAt
  ) {
    items {
      companyId
      createdAt
      downReason
      equipmentId
      equipmentName
      id
      initialStatus
      log
      owner
      promptDescription
      promptLabel
      promptTitle
      questionIndex
      reportId
      status
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDiscrepancyByUnitIdAndUpdatedAtQueryVariables,
  APITypes.ListDiscrepancyByUnitIdAndUpdatedAtQuery
>;
export const listDocuments = /* GraphQL */ `query ListDocuments(
  $filter: ModelDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      assignedSafetyLesson
      contentPath
      createdAt
      folderName
      id
      owner
      resourceLibraryID
      safetyLesson
      sharedWithCompanyIds
      title
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDocumentsQueryVariables,
  APITypes.ListDocumentsQuery
>;
export const listEquipment = /* GraphQL */ `query ListEquipment(
  $filter: ModelEquipmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listEquipment(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      formId
      id
      image
      name
      units
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEquipmentQueryVariables,
  APITypes.ListEquipmentQuery
>;
export const listEquipmentByCompanyId = /* GraphQL */ `query ListEquipmentByCompanyId(
  $companyId: String!
  $filter: ModelEquipmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEquipmentByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      formId
      id
      image
      name
      units
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEquipmentByCompanyIdQueryVariables,
  APITypes.ListEquipmentByCompanyIdQuery
>;
export const listEquipmentByFormId = /* GraphQL */ `query ListEquipmentByFormId(
  $filter: ModelEquipmentFilterInput
  $formId: String!
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEquipmentByFormId(
    filter: $filter
    formId: $formId
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      formId
      id
      image
      name
      units
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEquipmentByFormIdQueryVariables,
  APITypes.ListEquipmentByFormIdQuery
>;
export const listEquipmentCategories = /* GraphQL */ `query ListEquipmentCategories(
  $filter: ModelEquipmentCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listEquipmentCategories(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyId
      createdAt
      formId
      id
      image
      name
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEquipmentCategoriesQueryVariables,
  APITypes.ListEquipmentCategoriesQuery
>;
export const listEquipmentCategoryByCompanyId = /* GraphQL */ `query ListEquipmentCategoryByCompanyId(
  $companyId: String!
  $filter: ModelEquipmentCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEquipmentCategoryByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      formId
      id
      image
      name
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEquipmentCategoryByCompanyIdQueryVariables,
  APITypes.ListEquipmentCategoryByCompanyIdQuery
>;
export const listEquipmentCategoryByFormId = /* GraphQL */ `query ListEquipmentCategoryByFormId(
  $filter: ModelEquipmentCategoryFilterInput
  $formId: String!
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEquipmentCategoryByFormId(
    filter: $filter
    formId: $formId
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      formId
      id
      image
      name
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEquipmentCategoryByFormIdQueryVariables,
  APITypes.ListEquipmentCategoryByFormIdQuery
>;
export const listErrors = /* GraphQL */ `query ListErrors(
  $filter: ModelErrorsFilterInput
  $limit: Int
  $nextToken: String
) {
  listErrors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      createdAt
      errors
      id
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListErrorsQueryVariables,
  APITypes.ListErrorsQuery
>;
export const listExpenseCategories = /* GraphQL */ `query ListExpenseCategories(
  $filter: ModelExpenseCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listExpenseCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      id
      name
      owner
      startingBalance
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExpenseCategoriesQueryVariables,
  APITypes.ListExpenseCategoriesQuery
>;
export const listExpenseCategoryByCompanyId = /* GraphQL */ `query ListExpenseCategoryByCompanyId(
  $companyId: String!
  $filter: ModelExpenseCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listExpenseCategoryByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      id
      name
      owner
      startingBalance
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExpenseCategoryByCompanyIdQueryVariables,
  APITypes.ListExpenseCategoryByCompanyIdQuery
>;
export const listExpenseRecordByCompanyIdAndDateOfService = /* GraphQL */ `query ListExpenseRecordByCompanyIdAndDateOfService(
  $companyId: String!
  $dateOfService: ModelStringKeyConditionInput
  $filter: ModelExpenseRecordFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listExpenseRecordByCompanyIdAndDateOfService(
    companyId: $companyId
    dateOfService: $dateOfService
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      attachments
      companyId
      createdAt
      dateOfInput
      dateOfService
      equipmentCategoryId
      expenseCategories
      id
      invoiceNumber
      laborHoursOT
      laborHoursST
      laborRateOT
      laborRateST
      laborRateScheduleId
      laborRateScheduleName
      owner
      pmExpense
      pmServiceLevelId
      pmServiceLevelName
      totalExpense
      totalLaborCost
      unitId
      updatedAt
      vendorId
      vendorName
      workDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExpenseRecordByCompanyIdAndDateOfServiceQueryVariables,
  APITypes.ListExpenseRecordByCompanyIdAndDateOfServiceQuery
>;
export const listExpenseRecordByUnitIdAndDateOfService = /* GraphQL */ `query ListExpenseRecordByUnitIdAndDateOfService(
  $dateOfService: ModelStringKeyConditionInput
  $filter: ModelExpenseRecordFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listExpenseRecordByUnitIdAndDateOfService(
    dateOfService: $dateOfService
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      attachments
      companyId
      createdAt
      dateOfInput
      dateOfService
      equipmentCategoryId
      expenseCategories
      id
      invoiceNumber
      laborHoursOT
      laborHoursST
      laborRateOT
      laborRateST
      laborRateScheduleId
      laborRateScheduleName
      owner
      pmExpense
      pmServiceLevelId
      pmServiceLevelName
      totalExpense
      totalLaborCost
      unitId
      updatedAt
      vendorId
      vendorName
      workDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExpenseRecordByUnitIdAndDateOfServiceQueryVariables,
  APITypes.ListExpenseRecordByUnitIdAndDateOfServiceQuery
>;
export const listExpenseRecords = /* GraphQL */ `query ListExpenseRecords(
  $filter: ModelExpenseRecordFilterInput
  $limit: Int
  $nextToken: String
) {
  listExpenseRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      attachments
      companyId
      createdAt
      dateOfInput
      dateOfService
      equipmentCategoryId
      expenseCategories
      id
      invoiceNumber
      laborHoursOT
      laborHoursST
      laborRateOT
      laborRateST
      laborRateScheduleId
      laborRateScheduleName
      owner
      pmExpense
      pmServiceLevelId
      pmServiceLevelName
      totalExpense
      totalLaborCost
      unitId
      updatedAt
      vendorId
      vendorName
      workDescription
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExpenseRecordsQueryVariables,
  APITypes.ListExpenseRecordsQuery
>;
export const listFormByCompanyId = /* GraphQL */ `query ListFormByCompanyId(
  $companyId: String!
  $filter: ModelFormFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listFormByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      dailyServiceLogForm
      equipmentType
      formData
      formType
      id
      inspectionForm
      name
      noMachineHours
      noUMCounter
      owner
      pmServiceScheduleForm
      status
      umCounterLabel
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFormByCompanyIdQueryVariables,
  APITypes.ListFormByCompanyIdQuery
>;
export const listFormTemplateGroups = /* GraphQL */ `query ListFormTemplateGroups(
  $filter: ModelFormTemplateGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listFormTemplateGroups(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      createdAt
      description
      id
      name
      owner
      resourceLibraryID
      sharedWithCompanyIds
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFormTemplateGroupsQueryVariables,
  APITypes.ListFormTemplateGroupsQuery
>;
export const listFormTemplates = /* GraphQL */ `query ListFormTemplates(
  $filter: ModelFormTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listFormTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      createdAt
      createdByCompanyOwnerId
      dailyServiceLogForm
      formTemplateGroupID
      id
      inspectionForm
      originalCompanyId
      owner
      pmServiceScheduleForm
      templateData
      templateName
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFormTemplatesQueryVariables,
  APITypes.ListFormTemplatesQuery
>;
export const listForms = /* GraphQL */ `query ListForms(
  $filter: ModelFormFilterInput
  $limit: Int
  $nextToken: String
) {
  listForms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      dailyServiceLogForm
      equipmentType
      formData
      formType
      id
      inspectionForm
      name
      noMachineHours
      noUMCounter
      owner
      pmServiceScheduleForm
      status
      umCounterLabel
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListFormsQueryVariables, APITypes.ListFormsQuery>;
export const listHelpSupportDocs = /* GraphQL */ `query ListHelpSupportDocs(
  $filter: ModelHelpSupportDocFilterInput
  $limit: Int
  $nextToken: String
) {
  listHelpSupportDocs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      contentFilePath
      contentUrl
      createdAt
      createdByAdminId
      description
      docType
      id
      owner
      sharedWithCompanyIds
      status
      title
      updatedAt
      visibility
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHelpSupportDocsQueryVariables,
  APITypes.ListHelpSupportDocsQuery
>;
export const listInspectionReportByCompanyIdAndCreatedAt = /* GraphQL */ `query ListInspectionReportByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelInspectionReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listInspectionReportByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtInspection
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtInspection
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInspectionReportByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListInspectionReportByCompanyIdAndCreatedAtQuery
>;
export const listInspectionReportByEquipmentCategoryIdAndCreatedAt = /* GraphQL */ `query ListInspectionReportByEquipmentCategoryIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $equipmentCategoryId: String!
  $filter: ModelInspectionReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listInspectionReportByEquipmentCategoryIdAndCreatedAt(
    createdAt: $createdAt
    equipmentCategoryId: $equipmentCategoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtInspection
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtInspection
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInspectionReportByEquipmentCategoryIdAndCreatedAtQueryVariables,
  APITypes.ListInspectionReportByEquipmentCategoryIdAndCreatedAtQuery
>;
export const listInspectionReportByUnitIdAndCreatedAt = /* GraphQL */ `query ListInspectionReportByUnitIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelInspectionReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listInspectionReportByUnitIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtInspection
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtInspection
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInspectionReportByUnitIdAndCreatedAtQueryVariables,
  APITypes.ListInspectionReportByUnitIdAndCreatedAtQuery
>;
export const listInspectionReportByUserIdAndCreatedAt = /* GraphQL */ `query ListInspectionReportByUserIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelInspectionReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listInspectionReportByUserIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtInspection
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtInspection
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInspectionReportByUserIdAndCreatedAtQueryVariables,
  APITypes.ListInspectionReportByUserIdAndCreatedAtQuery
>;
export const listInspectionReports = /* GraphQL */ `query ListInspectionReports(
  $filter: ModelInspectionReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listInspectionReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      machineHoursAtInspection
      okCount
      photos
      responseData
      signature
      totalItems
      umCounterAtInspection
      unitId
      unitName
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInspectionReportsQueryVariables,
  APITypes.ListInspectionReportsQuery
>;
export const listInvoiceByCompanyIdAndDate = /* GraphQL */ `query ListInvoiceByCompanyIdAndDate(
  $companyId: String!
  $date: ModelStringKeyConditionInput
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listInvoiceByCompanyIdAndDate(
    companyId: $companyId
    date: $date
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      amount
      companyId
      createdAt
      date
      description
      id
      invoiceNumber
      lineItems
      owner
      pdfUrl
      status
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoiceByCompanyIdAndDateQueryVariables,
  APITypes.ListInvoiceByCompanyIdAndDateQuery
>;
export const listInvoices = /* GraphQL */ `query ListInvoices(
  $filter: ModelInvoiceFilterInput
  $limit: Int
  $nextToken: String
) {
  listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      amount
      companyId
      createdAt
      date
      description
      id
      invoiceNumber
      lineItems
      owner
      pdfUrl
      status
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoicesQueryVariables,
  APITypes.ListInvoicesQuery
>;
export const listLaborCategories = /* GraphQL */ `query ListLaborCategories(
  $filter: ModelLaborCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listLaborCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      id
      isActive
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLaborCategoriesQueryVariables,
  APITypes.ListLaborCategoriesQuery
>;
export const listLaborCategoryByCompanyId = /* GraphQL */ `query ListLaborCategoryByCompanyId(
  $companyId: String!
  $filter: ModelLaborCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLaborCategoryByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      id
      isActive
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLaborCategoryByCompanyIdQueryVariables,
  APITypes.ListLaborCategoryByCompanyIdQuery
>;
export const listLaborRateByCategoryIdAndEffectiveDate = /* GraphQL */ `query ListLaborRateByCategoryIdAndEffectiveDate(
  $categoryId: String!
  $effectiveDate: ModelStringKeyConditionInput
  $filter: ModelLaborRateFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLaborRateByCategoryIdAndEffectiveDate(
    categoryId: $categoryId
    effectiveDate: $effectiveDate
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      categoryId
      createdAt
      effectiveDate
      id
      overtimeRate
      owner
      standardRate
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLaborRateByCategoryIdAndEffectiveDateQueryVariables,
  APITypes.ListLaborRateByCategoryIdAndEffectiveDateQuery
>;
export const listLaborRates = /* GraphQL */ `query ListLaborRates(
  $filter: ModelLaborRateFilterInput
  $limit: Int
  $nextToken: String
) {
  listLaborRates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      categoryId
      createdAt
      effectiveDate
      id
      overtimeRate
      owner
      standardRate
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLaborRatesQueryVariables,
  APITypes.ListLaborRatesQuery
>;
export const listLibraryPlanTemplates = /* GraphQL */ `query ListLibraryPlanTemplates(
  $filter: ModelLibraryPlanTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listLibraryPlanTemplates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      categories
      categoryCount
      createdAt
      createdByAdminId
      createdByAdminName
      cycleDuration
      description
      governingStandard
      id
      minimumTimeRequired
      name
      owner
      sharedWithCompanyIds
      status
      topicCount
      updatedAt
      workingDays
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLibraryPlanTemplatesQueryVariables,
  APITypes.ListLibraryPlanTemplatesQuery
>;
export const listLibraryTopicTemplates = /* GraphQL */ `query ListLibraryTopicTemplates(
  $filter: ModelLibraryTopicTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listLibraryTopicTemplates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      contentFilePath
      contentUrl
      createdAt
      createdByAdminId
      description
      id
      owner
      style
      timeValue
      topicId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLibraryTopicTemplatesQueryVariables,
  APITypes.ListLibraryTopicTemplatesQuery
>;
export const listLocationByCompanyId = /* GraphQL */ `query ListLocationByCompanyId(
  $companyId: String!
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLocationByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      description
      id
      name
      owner
      regionalDivisionId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLocationByCompanyIdQueryVariables,
  APITypes.ListLocationByCompanyIdQuery
>;
export const listLocationByRegionalDivisionId = /* GraphQL */ `query ListLocationByRegionalDivisionId(
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
  $regionalDivisionId: String!
  $sortDirection: ModelSortDirection
) {
  listLocationByRegionalDivisionId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    regionalDivisionId: $regionalDivisionId
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      description
      id
      name
      owner
      regionalDivisionId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLocationByRegionalDivisionIdQueryVariables,
  APITypes.ListLocationByRegionalDivisionIdQuery
>;
export const listLocations = /* GraphQL */ `query ListLocations(
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      description
      id
      name
      owner
      regionalDivisionId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLocationsQueryVariables,
  APITypes.ListLocationsQuery
>;
export const listModuleSubscriptionByCompanyId = /* GraphQL */ `query ListModuleSubscriptionByCompanyId(
  $companyId: String!
  $filter: ModelModuleSubscriptionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listModuleSubscriptionByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      activatedAt
      cancelRequestedAt
      companyId
      createdAt
      effectiveEndDate
      id
      moduleKey
      monthlyRate
      owner
      pricingModel
      status
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListModuleSubscriptionByCompanyIdQueryVariables,
  APITypes.ListModuleSubscriptionByCompanyIdQuery
>;
export const listModuleSubscriptions = /* GraphQL */ `query ListModuleSubscriptions(
  $filter: ModelModuleSubscriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listModuleSubscriptions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      activatedAt
      cancelRequestedAt
      companyId
      createdAt
      effectiveEndDate
      id
      moduleKey
      monthlyRate
      owner
      pricingModel
      status
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListModuleSubscriptionsQueryVariables,
  APITypes.ListModuleSubscriptionsQuery
>;
export const listPMConfigurationByCompanyId = /* GraphQL */ `query ListPMConfigurationByCompanyId(
  $companyId: String!
  $filter: ModelPMConfigurationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPMConfigurationByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      dueSoonPercentage
      id
      laborCategoryId
      owner
      unitId
      unitOfMeasure
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMConfigurationByCompanyIdQueryVariables,
  APITypes.ListPMConfigurationByCompanyIdQuery
>;
export const listPMConfigurationByUnitId = /* GraphQL */ `query ListPMConfigurationByUnitId(
  $filter: ModelPMConfigurationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listPMConfigurationByUnitId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      companyId
      createdAt
      dueSoonPercentage
      id
      laborCategoryId
      owner
      unitId
      unitOfMeasure
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMConfigurationByUnitIdQueryVariables,
  APITypes.ListPMConfigurationByUnitIdQuery
>;
export const listPMConfigurations = /* GraphQL */ `query ListPMConfigurations(
  $filter: ModelPMConfigurationFilterInput
  $limit: Int
  $nextToken: String
) {
  listPMConfigurations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      dueSoonPercentage
      id
      laborCategoryId
      owner
      unitId
      unitOfMeasure
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMConfigurationsQueryVariables,
  APITypes.ListPMConfigurationsQuery
>;
export const listPMModuleContentByPmServiceFormId = /* GraphQL */ `query ListPMModuleContentByPmServiceFormId(
  $filter: ModelPMModuleContentFilterInput
  $limit: Int
  $nextToken: String
  $pmServiceFormId: String!
  $sortDirection: ModelSortDirection
) {
  listPMModuleContentByPmServiceFormId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pmServiceFormId: $pmServiceFormId
    sortDirection: $sortDirection
  ) {
    items {
      createdAt
      id
      owner
      pmServiceFormId
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMModuleContentByPmServiceFormIdQueryVariables,
  APITypes.ListPMModuleContentByPmServiceFormIdQuery
>;
export const listPMModuleContentByUnitId = /* GraphQL */ `query ListPMModuleContentByUnitId(
  $filter: ModelPMModuleContentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listPMModuleContentByUnitId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      createdAt
      id
      owner
      pmServiceFormId
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMModuleContentByUnitIdQueryVariables,
  APITypes.ListPMModuleContentByUnitIdQuery
>;
export const listPMModuleContents = /* GraphQL */ `query ListPMModuleContents(
  $filter: ModelPMModuleContentFilterInput
  $limit: Int
  $nextToken: String
) {
  listPMModuleContents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      createdAt
      id
      owner
      pmServiceFormId
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMModuleContentsQueryVariables,
  APITypes.ListPMModuleContentsQuery
>;
export const listPMNotificationSettingByPmConfigurationId = /* GraphQL */ `query ListPMNotificationSettingByPmConfigurationId(
  $filter: ModelPMNotificationSettingFilterInput
  $limit: Int
  $nextToken: String
  $pmConfigurationId: String!
  $sortDirection: ModelSortDirection
) {
  listPMNotificationSettingByPmConfigurationId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pmConfigurationId: $pmConfigurationId
    sortDirection: $sortDirection
  ) {
    items {
      createdAt
      emailThresholdUM
      id
      lastNotificationSent
      notificationFrequency
      owner
      pmConfigurationId
      recipients
      serviceLevelId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMNotificationSettingByPmConfigurationIdQueryVariables,
  APITypes.ListPMNotificationSettingByPmConfigurationIdQuery
>;
export const listPMNotificationSettings = /* GraphQL */ `query ListPMNotificationSettings(
  $filter: ModelPMNotificationSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  listPMNotificationSettings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      createdAt
      emailThresholdUM
      id
      lastNotificationSent
      notificationFrequency
      owner
      pmConfigurationId
      recipients
      serviceLevelId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMNotificationSettingsQueryVariables,
  APITypes.ListPMNotificationSettingsQuery
>;
export const listPMPartsAndProcedureByCompanyId = /* GraphQL */ `query ListPMPartsAndProcedureByCompanyId(
  $companyId: String!
  $filter: ModelPMPartsAndProcedureFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPMPartsAndProcedureByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      category
      companyId
      createdAt
      createdByUserId
      createdByUserName
      id
      itemName
      itemType
      manufacturer
      owner
      partNumber
      pmConfigurationId
      pmConfigurationIds
      price
      quantity
      sortOrder
      unitOfMeasure
      updatedAt
      vendorId
      vendorName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMPartsAndProcedureByCompanyIdQueryVariables,
  APITypes.ListPMPartsAndProcedureByCompanyIdQuery
>;
export const listPMPartsAndProcedureByPmConfigurationId = /* GraphQL */ `query ListPMPartsAndProcedureByPmConfigurationId(
  $filter: ModelPMPartsAndProcedureFilterInput
  $limit: Int
  $nextToken: String
  $pmConfigurationId: String!
  $sortDirection: ModelSortDirection
) {
  listPMPartsAndProcedureByPmConfigurationId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pmConfigurationId: $pmConfigurationId
    sortDirection: $sortDirection
  ) {
    items {
      category
      companyId
      createdAt
      createdByUserId
      createdByUserName
      id
      itemName
      itemType
      manufacturer
      owner
      partNumber
      pmConfigurationId
      pmConfigurationIds
      price
      quantity
      sortOrder
      unitOfMeasure
      updatedAt
      vendorId
      vendorName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMPartsAndProcedureByPmConfigurationIdQueryVariables,
  APITypes.ListPMPartsAndProcedureByPmConfigurationIdQuery
>;
export const listPMPartsAndProcedures = /* GraphQL */ `query ListPMPartsAndProcedures(
  $filter: ModelPMPartsAndProcedureFilterInput
  $limit: Int
  $nextToken: String
) {
  listPMPartsAndProcedures(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      category
      companyId
      createdAt
      createdByUserId
      createdByUserName
      id
      itemName
      itemType
      manufacturer
      owner
      partNumber
      pmConfigurationId
      pmConfigurationIds
      price
      quantity
      sortOrder
      unitOfMeasure
      updatedAt
      vendorId
      vendorName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMPartsAndProceduresQueryVariables,
  APITypes.ListPMPartsAndProceduresQuery
>;
export const listPMReportByCompanyIdAndCreatedAt = /* GraphQL */ `query ListPMReportByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelPMReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listPMReportByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      actualUM
      companyId
      createdAt
      id
      issueDescription
      issueTicketCreated
      issueTicketId
      laborHoursOT
      laborHoursST
      laborRateOT
      laborRateST
      laborRateScheduleId
      laborRateScheduleName
      owner
      photos
      pmConfigurationId
      reportData
      serviceDate
      serviceLevelId
      serviceLevelName
      signature
      status
      technicianId
      technicianName
      totalLaborCost
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMReportByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListPMReportByCompanyIdAndCreatedAtQuery
>;
export const listPMReportByPmConfigurationId = /* GraphQL */ `query ListPMReportByPmConfigurationId(
  $filter: ModelPMReportFilterInput
  $limit: Int
  $nextToken: String
  $pmConfigurationId: String!
  $sortDirection: ModelSortDirection
) {
  listPMReportByPmConfigurationId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pmConfigurationId: $pmConfigurationId
    sortDirection: $sortDirection
  ) {
    items {
      actualUM
      companyId
      createdAt
      id
      issueDescription
      issueTicketCreated
      issueTicketId
      laborHoursOT
      laborHoursST
      laborRateOT
      laborRateST
      laborRateScheduleId
      laborRateScheduleName
      owner
      photos
      pmConfigurationId
      reportData
      serviceDate
      serviceLevelId
      serviceLevelName
      signature
      status
      technicianId
      technicianName
      totalLaborCost
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMReportByPmConfigurationIdQueryVariables,
  APITypes.ListPMReportByPmConfigurationIdQuery
>;
export const listPMReportByUnitIdAndCreatedAt = /* GraphQL */ `query ListPMReportByUnitIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelPMReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listPMReportByUnitIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      actualUM
      companyId
      createdAt
      id
      issueDescription
      issueTicketCreated
      issueTicketId
      laborHoursOT
      laborHoursST
      laborRateOT
      laborRateST
      laborRateScheduleId
      laborRateScheduleName
      owner
      photos
      pmConfigurationId
      reportData
      serviceDate
      serviceLevelId
      serviceLevelName
      signature
      status
      technicianId
      technicianName
      totalLaborCost
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMReportByUnitIdAndCreatedAtQueryVariables,
  APITypes.ListPMReportByUnitIdAndCreatedAtQuery
>;
export const listPMReports = /* GraphQL */ `query ListPMReports(
  $filter: ModelPMReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listPMReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      actualUM
      companyId
      createdAt
      id
      issueDescription
      issueTicketCreated
      issueTicketId
      laborHoursOT
      laborHoursST
      laborRateOT
      laborRateST
      laborRateScheduleId
      laborRateScheduleName
      owner
      photos
      pmConfigurationId
      reportData
      serviceDate
      serviceLevelId
      serviceLevelName
      signature
      status
      technicianId
      technicianName
      totalLaborCost
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMReportsQueryVariables,
  APITypes.ListPMReportsQuery
>;
export const listPMServiceLevelByPmConfigurationId = /* GraphQL */ `query ListPMServiceLevelByPmConfigurationId(
  $filter: ModelPMServiceLevelFilterInput
  $limit: Int
  $nextToken: String
  $pmConfigurationId: String!
  $sortDirection: ModelSortDirection
) {
  listPMServiceLevelByPmConfigurationId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    pmConfigurationId: $pmConfigurationId
    sortDirection: $sortDirection
  ) {
    items {
      createdAt
      description
      id
      intervalValue
      lastServiceDate
      lastServiceUM
      levelIdentifier
      owner
      pmConfigurationId
      pmServiceFormId
      serviceLevelAssignments
      targetUM
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMServiceLevelByPmConfigurationIdQueryVariables,
  APITypes.ListPMServiceLevelByPmConfigurationIdQuery
>;
export const listPMServiceLevels = /* GraphQL */ `query ListPMServiceLevels(
  $filter: ModelPMServiceLevelFilterInput
  $limit: Int
  $nextToken: String
) {
  listPMServiceLevels(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      createdAt
      description
      id
      intervalValue
      lastServiceDate
      lastServiceUM
      levelIdentifier
      owner
      pmConfigurationId
      pmServiceFormId
      serviceLevelAssignments
      targetUM
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPMServiceLevelsQueryVariables,
  APITypes.ListPMServiceLevelsQuery
>;
export const listRegionalDivisionByCompanyId = /* GraphQL */ `query ListRegionalDivisionByCompanyId(
  $companyId: String!
  $filter: ModelRegionalDivisionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listRegionalDivisionByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      description
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRegionalDivisionByCompanyIdQueryVariables,
  APITypes.ListRegionalDivisionByCompanyIdQuery
>;
export const listRegionalDivisions = /* GraphQL */ `query ListRegionalDivisions(
  $filter: ModelRegionalDivisionFilterInput
  $limit: Int
  $nextToken: String
) {
  listRegionalDivisions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      description
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRegionalDivisionsQueryVariables,
  APITypes.ListRegionalDivisionsQuery
>;
export const listReportAnswerByCompanyId = /* GraphQL */ `query ListReportAnswerByCompanyId(
  $companyId: String!
  $filter: ModelReportAnswerFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReportAnswerByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      id
      notes
      parentReportId
      photos
      promptDescription
      promptKey
      promptLabel
      promptTitle
      promptType
      reportType
      sortOrder
      unitId
      updatedAt
      value
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportAnswerByCompanyIdQueryVariables,
  APITypes.ListReportAnswerByCompanyIdQuery
>;
export const listReportAnswerByParentReportIdAndCreatedAt = /* GraphQL */ `query ListReportAnswerByParentReportIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelReportAnswerFilterInput
  $limit: Int
  $nextToken: String
  $parentReportId: String!
  $sortDirection: ModelSortDirection
) {
  listReportAnswerByParentReportIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    parentReportId: $parentReportId
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      id
      notes
      parentReportId
      photos
      promptDescription
      promptKey
      promptLabel
      promptTitle
      promptType
      reportType
      sortOrder
      unitId
      updatedAt
      value
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportAnswerByParentReportIdAndCreatedAtQueryVariables,
  APITypes.ListReportAnswerByParentReportIdAndCreatedAtQuery
>;
export const listReportAnswerByPromptKeyAndValue = /* GraphQL */ `query ListReportAnswerByPromptKeyAndValue(
  $filter: ModelReportAnswerFilterInput
  $limit: Int
  $nextToken: String
  $promptKey: String!
  $sortDirection: ModelSortDirection
  $value: ModelStringKeyConditionInput
) {
  listReportAnswerByPromptKeyAndValue(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    promptKey: $promptKey
    sortDirection: $sortDirection
    value: $value
  ) {
    items {
      companyId
      createdAt
      id
      notes
      parentReportId
      photos
      promptDescription
      promptKey
      promptLabel
      promptTitle
      promptType
      reportType
      sortOrder
      unitId
      updatedAt
      value
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportAnswerByPromptKeyAndValueQueryVariables,
  APITypes.ListReportAnswerByPromptKeyAndValueQuery
>;
export const listReportAnswerByUnitId = /* GraphQL */ `query ListReportAnswerByUnitId(
  $filter: ModelReportAnswerFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listReportAnswerByUnitId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      companyId
      createdAt
      id
      notes
      parentReportId
      photos
      promptDescription
      promptKey
      promptLabel
      promptTitle
      promptType
      reportType
      sortOrder
      unitId
      updatedAt
      value
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportAnswerByUnitIdQueryVariables,
  APITypes.ListReportAnswerByUnitIdQuery
>;
export const listReportAnswers = /* GraphQL */ `query ListReportAnswers(
  $filter: ModelReportAnswerFilterInput
  $limit: Int
  $nextToken: String
) {
  listReportAnswers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      id
      notes
      parentReportId
      photos
      promptDescription
      promptKey
      promptLabel
      promptTitle
      promptType
      reportType
      sortOrder
      unitId
      updatedAt
      value
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportAnswersQueryVariables,
  APITypes.ListReportAnswersQuery
>;
export const listReports = /* GraphQL */ `query ListReports(
  $filter: ModelReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      dailyServiceLogReport
      equipmentId
      equipmentLocationId
      equipmentName
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportsQueryVariables,
  APITypes.ListReportsQuery
>;
export const listResourceLibraries = /* GraphQL */ `query ListResourceLibraries(
  $filter: ModelResourceLibraryFilterInput
  $limit: Int
  $nextToken: String
) {
  listResourceLibraries(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyOwnerId
      createdAt
      id
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListResourceLibrariesQueryVariables,
  APITypes.ListResourceLibrariesQuery
>;
export const listSavedReportConfigurationByCompanyIdAndCreatedAt = /* GraphQL */ `query ListSavedReportConfigurationByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelSavedReportConfigurationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSavedReportConfigurationByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      compareDateRangeEnd
      compareDateRangeStart
      createdAt
      dateRangeEnd
      dateRangeStart
      dateRangeType
      filtersJson
      groupByField
      id
      lastRunAt
      metricCategory
      metricKey
      reportName
      updatedAt
      userId
      visualizationType
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSavedReportConfigurationByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListSavedReportConfigurationByCompanyIdAndCreatedAtQuery
>;
export const listSavedReportConfigurationByUserIdAndCreatedAt = /* GraphQL */ `query ListSavedReportConfigurationByUserIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelSavedReportConfigurationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listSavedReportConfigurationByUserIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      companyId
      compareDateRangeEnd
      compareDateRangeStart
      createdAt
      dateRangeEnd
      dateRangeStart
      dateRangeType
      filtersJson
      groupByField
      id
      lastRunAt
      metricCategory
      metricKey
      reportName
      updatedAt
      userId
      visualizationType
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSavedReportConfigurationByUserIdAndCreatedAtQueryVariables,
  APITypes.ListSavedReportConfigurationByUserIdAndCreatedAtQuery
>;
export const listSavedReportConfigurations = /* GraphQL */ `query ListSavedReportConfigurations(
  $filter: ModelSavedReportConfigurationFilterInput
  $limit: Int
  $nextToken: String
) {
  listSavedReportConfigurations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyId
      compareDateRangeEnd
      compareDateRangeStart
      createdAt
      dateRangeEnd
      dateRangeStart
      dateRangeType
      filtersJson
      groupByField
      id
      lastRunAt
      metricCategory
      metricKey
      reportName
      updatedAt
      userId
      visualizationType
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSavedReportConfigurationsQueryVariables,
  APITypes.ListSavedReportConfigurationsQuery
>;
export const listSensitiveUserInfos = /* GraphQL */ `query ListSensitiveUserInfos(
  $filter: ModelSensitiveUserInfoFilterInput
  $limit: Int
  $nextToken: String
) {
  listSensitiveUserInfos(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      cognitoId
      companyId
      createdAt
      dateOfBirth
      driversLicenseClass
      driversLicenseExpirationDate
      driversLicenseNumber
      driversLicenseState
      emergencyContactName
      emergencyContactPhoneNumber
      emergencyContactRelationship
      id
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSensitiveUserInfosQueryVariables,
  APITypes.ListSensitiveUserInfosQuery
>;
export const listShiftReportByCompanyIdAndCreatedAt = /* GraphQL */ `query ListShiftReportByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelShiftReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listShiftReportByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      locationName
      okCount
      photos
      responseData
      shiftType
      signature
      totalItems
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListShiftReportByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListShiftReportByCompanyIdAndCreatedAtQuery
>;
export const listShiftReportByUserIdAndCreatedAt = /* GraphQL */ `query ListShiftReportByUserIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelShiftReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listShiftReportByUserIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      locationName
      okCount
      photos
      responseData
      shiftType
      signature
      totalItems
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListShiftReportByUserIdAndCreatedAtQueryVariables,
  APITypes.ListShiftReportByUserIdAndCreatedAtQuery
>;
export const listShiftReports = /* GraphQL */ `query ListShiftReports(
  $filter: ModelShiftReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listShiftReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      locationId
      locationName
      okCount
      photos
      responseData
      shiftType
      signature
      totalItems
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListShiftReportsQueryVariables,
  APITypes.ListShiftReportsQuery
>;
export const listSingleUnits = /* GraphQL */ `query ListSingleUnits(
  $filter: ModelSingleUnitFilterInput
  $limit: Int
  $nextToken: String
) {
  listSingleUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      annualProjectedUsage
      aquisitionCost
      aquisitionDate
      assignedTo
      axleConfiguration
      categoryId
      costTrackingModuleEnrollment
      createdAt
      currentMachineHours
      currentUMCounterValue
      dailyServiceLogFormId
      description
      dispositionDate
      dispositionReason
      downReason
      engineManufacturer
      engineModelNumber
      equipmentStatus
      extraUnitInfo
      id
      image
      inputByPerson
      inputDate
      lastDailyServiceDate
      lastInspectionDate
      lastServiceHours
      licenseNumber
      locationId
      machineHoursAtAquisition
      machineUMCounterAtAquisition
      manufactureDate
      manufacturerName
      modelNumber
      name
      pmModuleEnrollment
      putInServiceDate
      removedFromServiceDate
      removedFromServiceReason
      replacedUMCounterHistory
      replacedUMCounterStatus
      replacedUMCounterValue
      serialNumber
      tiresModuleEnrollment
      unitOfMeasure
      updatedAt
      utilizationAdjustmentDays
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSingleUnitsQueryVariables,
  APITypes.ListSingleUnitsQuery
>;
export const listSingleUnitsByCategoryId = /* GraphQL */ `query ListSingleUnitsByCategoryId(
  $categoryId: ID!
  $filter: ModelSingleUnitFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSingleUnitsByCategoryId(
    categoryId: $categoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      annualProjectedUsage
      aquisitionCost
      aquisitionDate
      assignedTo
      axleConfiguration
      categoryId
      costTrackingModuleEnrollment
      createdAt
      currentMachineHours
      currentUMCounterValue
      dailyServiceLogFormId
      description
      dispositionDate
      dispositionReason
      downReason
      engineManufacturer
      engineModelNumber
      equipmentStatus
      extraUnitInfo
      id
      image
      inputByPerson
      inputDate
      lastDailyServiceDate
      lastInspectionDate
      lastServiceHours
      licenseNumber
      locationId
      machineHoursAtAquisition
      machineUMCounterAtAquisition
      manufactureDate
      manufacturerName
      modelNumber
      name
      pmModuleEnrollment
      putInServiceDate
      removedFromServiceDate
      removedFromServiceReason
      replacedUMCounterHistory
      replacedUMCounterStatus
      replacedUMCounterValue
      serialNumber
      tiresModuleEnrollment
      unitOfMeasure
      updatedAt
      utilizationAdjustmentDays
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSingleUnitsByCategoryIdQueryVariables,
  APITypes.ListSingleUnitsByCategoryIdQuery
>;
export const listSkillAssignments = /* GraphQL */ `query ListSkillAssignments(
  $filter: ModelSkillAssignmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkillAssignments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      evaluatedBy
      evaluatedByName
      evaluationDate
      id
      owner
      skillLevel
      subCategoryId
      taskId
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillAssignmentsQueryVariables,
  APITypes.ListSkillAssignmentsQuery
>;
export const listSkillCategories = /* GraphQL */ `query ListSkillCategories(
  $filter: ModelSkillCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkillCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      allowMachineNumber
      classificationId
      companyId
      createdAt
      equipmentCategoryId
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillCategoriesQueryVariables,
  APITypes.ListSkillCategoriesQuery
>;
export const listSkillLevels = /* GraphQL */ `query ListSkillLevels(
  $filter: ModelSkillLevelFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkillLevels(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      color
      companyId
      createdAt
      description
      id
      name
      owner
      sortOrder
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillLevelsQueryVariables,
  APITypes.ListSkillLevelsQuery
>;
export const listSkillTasks = /* GraphQL */ `query ListSkillTasks(
  $filter: ModelSkillTaskFilterInput
  $limit: Int
  $nextToken: String
) {
  listSkillTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      categoryId
      companyId
      createdAt
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSkillTasksQueryVariables,
  APITypes.ListSkillTasksQuery
>;
export const listSubCategories = /* GraphQL */ `query ListSubCategories(
  $filter: ModelSubCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listSubCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      categoryId
      companyId
      createdAt
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSubCategoriesQueryVariables,
  APITypes.ListSubCategoriesQuery
>;
export const listTireByCompanyId = /* GraphQL */ `query ListTireByCompanyId(
  $companyId: String!
  $filter: ModelTireFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTireByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      assignedAxle
      assignedPosition
      companyId
      createdAt
      currentTirePressure
      currentTreadDepth
      dateInstalled
      dateUninstalled
      failureReason
      id
      inflationMedium
      loadRating
      loadRatingUnit
      minimumTreadDepth
      name
      owner
      recommendedTirePressure
      removedFromService
      removedFromServiceDate
      tireCategory
      tireManufacturer
      tireModel
      tireSize
      tireStatus
      treadDepthAtInstall
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTireByCompanyIdQueryVariables,
  APITypes.ListTireByCompanyIdQuery
>;
export const listTireByUnitId = /* GraphQL */ `query ListTireByUnitId(
  $filter: ModelTireFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listTireByUnitId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      assignedAxle
      assignedPosition
      companyId
      createdAt
      currentTirePressure
      currentTreadDepth
      dateInstalled
      dateUninstalled
      failureReason
      id
      inflationMedium
      loadRating
      loadRatingUnit
      minimumTreadDepth
      name
      owner
      recommendedTirePressure
      removedFromService
      removedFromServiceDate
      tireCategory
      tireManufacturer
      tireModel
      tireSize
      tireStatus
      treadDepthAtInstall
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTireByUnitIdQueryVariables,
  APITypes.ListTireByUnitIdQuery
>;
export const listTireReports = /* GraphQL */ `query ListTireReports(
  $filter: ModelTireReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listTireReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      equipmentLocationId
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      tireId
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTireReportsQueryVariables,
  APITypes.ListTireReportsQuery
>;
export const listTires = /* GraphQL */ `query ListTires(
  $filter: ModelTireFilterInput
  $limit: Int
  $nextToken: String
) {
  listTires(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      assignedAxle
      assignedPosition
      companyId
      createdAt
      currentTirePressure
      currentTreadDepth
      dateInstalled
      dateUninstalled
      failureReason
      id
      inflationMedium
      loadRating
      loadRatingUnit
      minimumTreadDepth
      name
      owner
      recommendedTirePressure
      removedFromService
      removedFromServiceDate
      tireCategory
      tireManufacturer
      tireModel
      tireSize
      tireStatus
      treadDepthAtInstall
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListTiresQueryVariables, APITypes.ListTiresQuery>;
export const listTrainingAffidavitByCompanyId = /* GraphQL */ `query ListTrainingAffidavitByCompanyId(
  $companyId: String!
  $filter: ModelTrainingAffidavitFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTrainingAffidavitByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      adminId
      affidavitDate
      companyId
      createdAt
      id
      legalText
      nextDueDate
      owner
      planId
      signaturePath
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingAffidavitByCompanyIdQueryVariables,
  APITypes.ListTrainingAffidavitByCompanyIdQuery
>;
export const listTrainingAffidavitByPlanId = /* GraphQL */ `query ListTrainingAffidavitByPlanId(
  $filter: ModelTrainingAffidavitFilterInput
  $limit: Int
  $nextToken: String
  $planId: String!
  $sortDirection: ModelSortDirection
) {
  listTrainingAffidavitByPlanId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    planId: $planId
    sortDirection: $sortDirection
  ) {
    items {
      adminId
      affidavitDate
      companyId
      createdAt
      id
      legalText
      nextDueDate
      owner
      planId
      signaturePath
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingAffidavitByPlanIdQueryVariables,
  APITypes.ListTrainingAffidavitByPlanIdQuery
>;
export const listTrainingAffidavits = /* GraphQL */ `query ListTrainingAffidavits(
  $filter: ModelTrainingAffidavitFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrainingAffidavits(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      adminId
      affidavitDate
      companyId
      createdAt
      id
      legalText
      nextDueDate
      owner
      planId
      signaturePath
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingAffidavitsQueryVariables,
  APITypes.ListTrainingAffidavitsQuery
>;
export const listTrainingCompletionByCompanyId = /* GraphQL */ `query ListTrainingCompletionByCompanyId(
  $companyId: String!
  $filter: ModelTrainingCompletionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTrainingCompletionByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      categoryId
      companyId
      completionDate
      createdAt
      id
      launched
      markedAsViewed
      owner
      planId
      scheduleDate
      signaturePath
      timeValueMinutes
      topicId
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingCompletionByCompanyIdQueryVariables,
  APITypes.ListTrainingCompletionByCompanyIdQuery
>;
export const listTrainingCompletionByPlanId = /* GraphQL */ `query ListTrainingCompletionByPlanId(
  $filter: ModelTrainingCompletionFilterInput
  $limit: Int
  $nextToken: String
  $planId: String!
  $sortDirection: ModelSortDirection
) {
  listTrainingCompletionByPlanId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    planId: $planId
    sortDirection: $sortDirection
  ) {
    items {
      categoryId
      companyId
      completionDate
      createdAt
      id
      launched
      markedAsViewed
      owner
      planId
      scheduleDate
      signaturePath
      timeValueMinutes
      topicId
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingCompletionByPlanIdQueryVariables,
  APITypes.ListTrainingCompletionByPlanIdQuery
>;
export const listTrainingCompletionByScheduledDate = /* GraphQL */ `query ListTrainingCompletionByScheduledDate(
  $filter: ModelTrainingCompletionFilterInput
  $limit: Int
  $nextToken: String
  $scheduleDate: String!
  $sortDirection: ModelSortDirection
) {
  listTrainingCompletionByScheduledDate(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    scheduleDate: $scheduleDate
    sortDirection: $sortDirection
  ) {
    items {
      categoryId
      companyId
      completionDate
      createdAt
      id
      launched
      markedAsViewed
      owner
      planId
      scheduleDate
      signaturePath
      timeValueMinutes
      topicId
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingCompletionByScheduledDateQueryVariables,
  APITypes.ListTrainingCompletionByScheduledDateQuery
>;
export const listTrainingCompletionByUserIdAndCompletionDate = /* GraphQL */ `query ListTrainingCompletionByUserIdAndCompletionDate(
  $completionDate: ModelStringKeyConditionInput
  $filter: ModelTrainingCompletionFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listTrainingCompletionByUserIdAndCompletionDate(
    completionDate: $completionDate
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      categoryId
      companyId
      completionDate
      createdAt
      id
      launched
      markedAsViewed
      owner
      planId
      scheduleDate
      signaturePath
      timeValueMinutes
      topicId
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingCompletionByUserIdAndCompletionDateQueryVariables,
  APITypes.ListTrainingCompletionByUserIdAndCompletionDateQuery
>;
export const listTrainingCompletions = /* GraphQL */ `query ListTrainingCompletions(
  $filter: ModelTrainingCompletionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrainingCompletions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      categoryId
      companyId
      completionDate
      createdAt
      id
      launched
      markedAsViewed
      owner
      planId
      scheduleDate
      signaturePath
      timeValueMinutes
      topicId
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingCompletionsQueryVariables,
  APITypes.ListTrainingCompletionsQuery
>;
export const listTrainingEnrollmentByCompanyId = /* GraphQL */ `query ListTrainingEnrollmentByCompanyId(
  $companyId: String!
  $filter: ModelTrainingEnrollmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTrainingEnrollmentByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      enrolledDate
      id
      lastCompletionDate
      nextDueDate
      owner
      planId
      status
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingEnrollmentByCompanyIdQueryVariables,
  APITypes.ListTrainingEnrollmentByCompanyIdQuery
>;
export const listTrainingEnrollmentByPlanId = /* GraphQL */ `query ListTrainingEnrollmentByPlanId(
  $filter: ModelTrainingEnrollmentFilterInput
  $limit: Int
  $nextToken: String
  $planId: String!
  $sortDirection: ModelSortDirection
) {
  listTrainingEnrollmentByPlanId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    planId: $planId
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      enrolledDate
      id
      lastCompletionDate
      nextDueDate
      owner
      planId
      status
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingEnrollmentByPlanIdQueryVariables,
  APITypes.ListTrainingEnrollmentByPlanIdQuery
>;
export const listTrainingEnrollmentByUserId = /* GraphQL */ `query ListTrainingEnrollmentByUserId(
  $filter: ModelTrainingEnrollmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listTrainingEnrollmentByUserId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      companyId
      createdAt
      enrolledDate
      id
      lastCompletionDate
      nextDueDate
      owner
      planId
      status
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingEnrollmentByUserIdQueryVariables,
  APITypes.ListTrainingEnrollmentByUserIdQuery
>;
export const listTrainingEnrollments = /* GraphQL */ `query ListTrainingEnrollments(
  $filter: ModelTrainingEnrollmentFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrainingEnrollments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyId
      createdAt
      enrolledDate
      id
      lastCompletionDate
      nextDueDate
      owner
      planId
      status
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingEnrollmentsQueryVariables,
  APITypes.ListTrainingEnrollmentsQuery
>;
export const listTrainingPlanByCompanyId = /* GraphQL */ `query ListTrainingPlanByCompanyId(
  $companyId: String!
  $filter: ModelTrainingPlanFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTrainingPlanByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      categories
      companyId
      createdAt
      cycleDuration
      governingStandard
      holidays
      id
      minimumTimeRequired
      name
      owner
      startDate
      status
      updatedAt
      workingDays
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingPlanByCompanyIdQueryVariables,
  APITypes.ListTrainingPlanByCompanyIdQuery
>;
export const listTrainingPlans = /* GraphQL */ `query ListTrainingPlans(
  $filter: ModelTrainingPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrainingPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      categories
      companyId
      createdAt
      cycleDuration
      governingStandard
      holidays
      id
      minimumTimeRequired
      name
      owner
      startDate
      status
      updatedAt
      workingDays
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingPlansQueryVariables,
  APITypes.ListTrainingPlansQuery
>;
export const listTrainingQuizResponses = /* GraphQL */ `query ListTrainingQuizResponses(
  $filter: ModelTrainingQuizResponseFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrainingQuizResponses(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      attemptNumber
      categoryId
      companyId
      completedAt
      createdAt
      cycleStartDate
      formId
      id
      owner
      passed
      planId
      responseData
      score
      signaturePath
      totalQuestions
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingQuizResponsesQueryVariables,
  APITypes.ListTrainingQuizResponsesQuery
>;
export const listTrainingScheduleByCompanyId = /* GraphQL */ `query ListTrainingScheduleByCompanyId(
  $companyId: String!
  $filter: ModelTrainingScheduleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTrainingScheduleByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      assignedUserId
      categoryId
      companyId
      createdAt
      dayNumber
      id
      locked
      owner
      planId
      scheduledDate
      topicId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingScheduleByCompanyIdQueryVariables,
  APITypes.ListTrainingScheduleByCompanyIdQuery
>;
export const listTrainingScheduleByPlanIdAndScheduledDate = /* GraphQL */ `query ListTrainingScheduleByPlanIdAndScheduledDate(
  $filter: ModelTrainingScheduleFilterInput
  $limit: Int
  $nextToken: String
  $planId: String!
  $scheduledDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
) {
  listTrainingScheduleByPlanIdAndScheduledDate(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    planId: $planId
    scheduledDate: $scheduledDate
    sortDirection: $sortDirection
  ) {
    items {
      assignedUserId
      categoryId
      companyId
      createdAt
      dayNumber
      id
      locked
      owner
      planId
      scheduledDate
      topicId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingScheduleByPlanIdAndScheduledDateQueryVariables,
  APITypes.ListTrainingScheduleByPlanIdAndScheduledDateQuery
>;
export const listTrainingScheduleByScheduledDate = /* GraphQL */ `query ListTrainingScheduleByScheduledDate(
  $filter: ModelTrainingScheduleFilterInput
  $limit: Int
  $nextToken: String
  $scheduledDate: String!
  $sortDirection: ModelSortDirection
) {
  listTrainingScheduleByScheduledDate(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    scheduledDate: $scheduledDate
    sortDirection: $sortDirection
  ) {
    items {
      assignedUserId
      categoryId
      companyId
      createdAt
      dayNumber
      id
      locked
      owner
      planId
      scheduledDate
      topicId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingScheduleByScheduledDateQueryVariables,
  APITypes.ListTrainingScheduleByScheduledDateQuery
>;
export const listTrainingSchedules = /* GraphQL */ `query ListTrainingSchedules(
  $filter: ModelTrainingScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrainingSchedules(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      assignedUserId
      categoryId
      companyId
      createdAt
      dayNumber
      id
      locked
      owner
      planId
      scheduledDate
      topicId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingSchedulesQueryVariables,
  APITypes.ListTrainingSchedulesQuery
>;
export const listTrainingTopicByCompanyId = /* GraphQL */ `query ListTrainingTopicByCompanyId(
  $companyId: String!
  $filter: ModelTrainingTopicFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listTrainingTopicByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      categoryIds
      companyId
      companyResourceId
      contentFilePath
      contentUrl
      createdAt
      description
      id
      owner
      planIds
      style
      timeValue
      topicId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingTopicByCompanyIdQueryVariables,
  APITypes.ListTrainingTopicByCompanyIdQuery
>;
export const listTrainingTopicByTopicId = /* GraphQL */ `query ListTrainingTopicByTopicId(
  $filter: ModelTrainingTopicFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $topicId: String!
) {
  listTrainingTopicByTopicId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    topicId: $topicId
  ) {
    items {
      categoryIds
      companyId
      companyResourceId
      contentFilePath
      contentUrl
      createdAt
      description
      id
      owner
      planIds
      style
      timeValue
      topicId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingTopicByTopicIdQueryVariables,
  APITypes.ListTrainingTopicByTopicIdQuery
>;
export const listTrainingTopics = /* GraphQL */ `query ListTrainingTopics(
  $filter: ModelTrainingTopicFilterInput
  $limit: Int
  $nextToken: String
) {
  listTrainingTopics(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      categoryIds
      companyId
      companyResourceId
      contentFilePath
      contentUrl
      createdAt
      description
      id
      owner
      planIds
      style
      timeValue
      topicId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTrainingTopicsQueryVariables,
  APITypes.ListTrainingTopicsQuery
>;
export const listUnitExpenseBudgetByCompanyId = /* GraphQL */ `query ListUnitExpenseBudgetByCompanyId(
  $companyId: String!
  $filter: ModelUnitExpenseBudgetFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUnitExpenseBudgetByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      expenseCategoryId
      id
      owner
      startingBalance
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUnitExpenseBudgetByCompanyIdQueryVariables,
  APITypes.ListUnitExpenseBudgetByCompanyIdQuery
>;
export const listUnitExpenseBudgetByExpenseCategoryId = /* GraphQL */ `query ListUnitExpenseBudgetByExpenseCategoryId(
  $expenseCategoryId: String!
  $filter: ModelUnitExpenseBudgetFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUnitExpenseBudgetByExpenseCategoryId(
    expenseCategoryId: $expenseCategoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      expenseCategoryId
      id
      owner
      startingBalance
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUnitExpenseBudgetByExpenseCategoryIdQueryVariables,
  APITypes.ListUnitExpenseBudgetByExpenseCategoryIdQuery
>;
export const listUnitExpenseBudgetByUnitId = /* GraphQL */ `query ListUnitExpenseBudgetByUnitId(
  $filter: ModelUnitExpenseBudgetFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  listUnitExpenseBudgetByUnitId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      companyId
      createdAt
      expenseCategoryId
      id
      owner
      startingBalance
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUnitExpenseBudgetByUnitIdQueryVariables,
  APITypes.ListUnitExpenseBudgetByUnitIdQuery
>;
export const listUnitExpenseBudgets = /* GraphQL */ `query ListUnitExpenseBudgets(
  $filter: ModelUnitExpenseBudgetFilterInput
  $limit: Int
  $nextToken: String
) {
  listUnitExpenseBudgets(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyId
      createdAt
      expenseCategoryId
      id
      owner
      startingBalance
      unitId
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUnitExpenseBudgetsQueryVariables,
  APITypes.ListUnitExpenseBudgetsQuery
>;
export const listUserFiles = /* GraphQL */ `query ListUserFiles(
  $filter: ModelUserFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      companyId
      createdAt
      fileName
      fileSize
      id
      owner
      s3Path
      updatedAt
      uploadedAt
      uploadedBy
      uploadedByName
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserFilesQueryVariables,
  APITypes.ListUserFilesQuery
>;
export const listUserReportFavoriteByCompanyId = /* GraphQL */ `query ListUserReportFavoriteByCompanyId(
  $companyId: String!
  $filter: ModelUserReportFavoriteFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserReportFavoriteByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      id
      reportTypeKey
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserReportFavoriteByCompanyIdQueryVariables,
  APITypes.ListUserReportFavoriteByCompanyIdQuery
>;
export const listUserReportFavoriteByUserIdAndReportTypeKey = /* GraphQL */ `query ListUserReportFavoriteByUserIdAndReportTypeKey(
  $filter: ModelUserReportFavoriteFilterInput
  $limit: Int
  $nextToken: String
  $reportTypeKey: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listUserReportFavoriteByUserIdAndReportTypeKey(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    reportTypeKey: $reportTypeKey
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      companyId
      createdAt
      id
      reportTypeKey
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserReportFavoriteByUserIdAndReportTypeKeyQueryVariables,
  APITypes.ListUserReportFavoriteByUserIdAndReportTypeKeyQuery
>;
export const listUserReportFavorites = /* GraphQL */ `query ListUserReportFavorites(
  $filter: ModelUserReportFavoriteFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserReportFavorites(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      companyId
      createdAt
      id
      reportTypeKey
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserReportFavoritesQueryVariables,
  APITypes.ListUserReportFavoritesQuery
>;
export const listUserSkillReportByCompanyIdAndCreatedAt = /* GraphQL */ `query ListUserSkillReportByCompanyIdAndCreatedAt(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelUserSkillReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listUserSkillReportByCompanyIdAndCreatedAt(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      assessorId
      assessorName
      companyId
      createdAt
      expirationDate
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      okCount
      passFailStatus
      photos
      qualificationLevel
      responseData
      signature
      skillCategory
      skillName
      totalItems
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserSkillReportByCompanyIdAndCreatedAtQueryVariables,
  APITypes.ListUserSkillReportByCompanyIdAndCreatedAtQuery
>;
export const listUserSkillReportByUserIdAndCreatedAt = /* GraphQL */ `query ListUserSkillReportByUserIdAndCreatedAt(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelUserSkillReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  listUserSkillReportByUserIdAndCreatedAt(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      assessorId
      assessorName
      companyId
      createdAt
      expirationDate
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      okCount
      passFailStatus
      photos
      qualificationLevel
      responseData
      signature
      skillCategory
      skillName
      totalItems
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserSkillReportByUserIdAndCreatedAtQueryVariables,
  APITypes.ListUserSkillReportByUserIdAndCreatedAtQuery
>;
export const listUserSkillReports = /* GraphQL */ `query ListUserSkillReports(
  $filter: ModelUserSkillReportFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserSkillReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      assessorId
      assessorName
      companyId
      createdAt
      expirationDate
      formId
      gpsLatitude
      gpsLocationType
      gpsLongitude
      id
      inopCount
      inspectionCompleted
      inspectionDurationSeconds
      inspectionStarted
      okCount
      passFailStatus
      photos
      qualificationLevel
      responseData
      signature
      skillCategory
      skillName
      totalItems
      updatedAt
      userId
      userName
      warnCount
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserSkillReportsQueryVariables,
  APITypes.ListUserSkillReportsQuery
>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      archived
      cognitoId
      companyId
      contactPhoneNumber
      contactPhoneType
      createdAt
      currentJobClassification
      dateOfHire
      discrepancyNotification
      discrepancyNotificationTypes
      domain
      driversLicenseStatus
      email
      globalLocationPermission
      id
      inputByPerson
      inputDate
      locationAssignment
      name
      notesAboutUser
      onHighwayEligibility
      owner
      permissions
      personalIdentification
      pmNotification
      pmNotificationTypes
      position
      regionalAssignment
      role
      safetyLessons
      skillTrackingModuleEnrollment
      trainingModuleEnrollment
      trainingNotification
      trainingNotificationTypes
      updatedAt
      userPhoto
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const listVendorListByCompanyIdAndUpdatedAt = /* GraphQL */ `query ListVendorListByCompanyIdAndUpdatedAt(
  $companyId: String!
  $filter: ModelVendorListFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $updatedAt: ModelStringKeyConditionInput
) {
  listVendorListByCompanyIdAndUpdatedAt(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    updatedAt: $updatedAt
  ) {
    items {
      address
      companyId
      createdAt
      faxNumber
      id
      name
      owner
      phoneNumber
      repName
      repPhoneNumber
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVendorListByCompanyIdAndUpdatedAtQueryVariables,
  APITypes.ListVendorListByCompanyIdAndUpdatedAtQuery
>;
export const listVendorLists = /* GraphQL */ `query ListVendorLists(
  $filter: ModelVendorListFilterInput
  $limit: Int
  $nextToken: String
) {
  listVendorLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      address
      companyId
      createdAt
      faxNumber
      id
      name
      owner
      phoneNumber
      repName
      repPhoneNumber
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVendorListsQueryVariables,
  APITypes.ListVendorListsQuery
>;
export const listVideos = /* GraphQL */ `query ListVideos(
  $filter: ModelVideoFilterInput
  $limit: Int
  $nextToken: String
) {
  listVideos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      assignedSafetyLesson
      contentPath
      createdAt
      folderName
      id
      owner
      resourceLibraryID
      safetyLesson
      sharedWithCompanyIds
      title
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVideosQueryVariables,
  APITypes.ListVideosQuery
>;
export const reportsByCompanyId = /* GraphQL */ `query ReportsByCompanyId(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  reportsByCompanyId(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      dailyServiceLogReport
      equipmentId
      equipmentLocationId
      equipmentName
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReportsByCompanyIdQueryVariables,
  APITypes.ReportsByCompanyIdQuery
>;
export const reportsByEquipmentId = /* GraphQL */ `query ReportsByEquipmentId(
  $createdAt: ModelStringKeyConditionInput
  $equipmentId: String!
  $filter: ModelReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  reportsByEquipmentId(
    createdAt: $createdAt
    equipmentId: $equipmentId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      dailyServiceLogReport
      equipmentId
      equipmentLocationId
      equipmentName
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReportsByEquipmentIdQueryVariables,
  APITypes.ReportsByEquipmentIdQuery
>;
export const reportsByUnitId = /* GraphQL */ `query ReportsByUnitId(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  reportsByUnitId(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      dailyServiceLogReport
      equipmentId
      equipmentLocationId
      equipmentName
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReportsByUnitIdQueryVariables,
  APITypes.ReportsByUnitIdQuery
>;
export const sensitiveUserInfoByCognitoId = /* GraphQL */ `query SensitiveUserInfoByCognitoId(
  $cognitoId: String!
  $filter: ModelSensitiveUserInfoFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  sensitiveUserInfoByCognitoId(
    cognitoId: $cognitoId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      cognitoId
      companyId
      createdAt
      dateOfBirth
      driversLicenseClass
      driversLicenseExpirationDate
      driversLicenseNumber
      driversLicenseState
      emergencyContactName
      emergencyContactPhoneNumber
      emergencyContactRelationship
      id
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SensitiveUserInfoByCognitoIdQueryVariables,
  APITypes.SensitiveUserInfoByCognitoIdQuery
>;
export const sensitiveUserInfoByCompanyId = /* GraphQL */ `query SensitiveUserInfoByCompanyId(
  $companyId: String!
  $filter: ModelSensitiveUserInfoFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  sensitiveUserInfoByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      cognitoId
      companyId
      createdAt
      dateOfBirth
      driversLicenseClass
      driversLicenseExpirationDate
      driversLicenseNumber
      driversLicenseState
      emergencyContactName
      emergencyContactPhoneNumber
      emergencyContactRelationship
      id
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SensitiveUserInfoByCompanyIdQueryVariables,
  APITypes.SensitiveUserInfoByCompanyIdQuery
>;
export const skillAssignmentsByCompanyId = /* GraphQL */ `query SkillAssignmentsByCompanyId(
  $companyId: String!
  $filter: ModelSkillAssignmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  skillAssignmentsByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      evaluatedBy
      evaluatedByName
      evaluationDate
      id
      owner
      skillLevel
      subCategoryId
      taskId
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillAssignmentsByCompanyIdQueryVariables,
  APITypes.SkillAssignmentsByCompanyIdQuery
>;
export const skillAssignmentsByUserId = /* GraphQL */ `query SkillAssignmentsByUserId(
  $filter: ModelSkillAssignmentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  skillAssignmentsByUserId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      companyId
      createdAt
      evaluatedBy
      evaluatedByName
      evaluationDate
      id
      owner
      skillLevel
      subCategoryId
      taskId
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillAssignmentsByUserIdQueryVariables,
  APITypes.SkillAssignmentsByUserIdQuery
>;
export const skillCategoriesByClassificationId = /* GraphQL */ `query SkillCategoriesByClassificationId(
  $classificationId: String!
  $filter: ModelSkillCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  skillCategoriesByClassificationId(
    classificationId: $classificationId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      allowMachineNumber
      classificationId
      companyId
      createdAt
      equipmentCategoryId
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillCategoriesByClassificationIdQueryVariables,
  APITypes.SkillCategoriesByClassificationIdQuery
>;
export const skillCategoriesByCompanyId = /* GraphQL */ `query SkillCategoriesByCompanyId(
  $companyId: String!
  $filter: ModelSkillCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  skillCategoriesByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      allowMachineNumber
      classificationId
      companyId
      createdAt
      equipmentCategoryId
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillCategoriesByCompanyIdQueryVariables,
  APITypes.SkillCategoriesByCompanyIdQuery
>;
export const skillLevelsByCompanyId = /* GraphQL */ `query SkillLevelsByCompanyId(
  $companyId: String!
  $filter: ModelSkillLevelFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  skillLevelsByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      color
      companyId
      createdAt
      description
      id
      name
      owner
      sortOrder
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillLevelsByCompanyIdQueryVariables,
  APITypes.SkillLevelsByCompanyIdQuery
>;
export const skillTasksByCategoryId = /* GraphQL */ `query SkillTasksByCategoryId(
  $categoryId: String!
  $filter: ModelSkillTaskFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  skillTasksByCategoryId(
    categoryId: $categoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      categoryId
      companyId
      createdAt
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillTasksByCategoryIdQueryVariables,
  APITypes.SkillTasksByCategoryIdQuery
>;
export const skillTasksByCompanyId = /* GraphQL */ `query SkillTasksByCompanyId(
  $companyId: String!
  $filter: ModelSkillTaskFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  skillTasksByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      categoryId
      companyId
      createdAt
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SkillTasksByCompanyIdQueryVariables,
  APITypes.SkillTasksByCompanyIdQuery
>;
export const subCategoriesByCategoryId = /* GraphQL */ `query SubCategoriesByCategoryId(
  $categoryId: String!
  $filter: ModelSubCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  subCategoriesByCategoryId(
    categoryId: $categoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      categoryId
      companyId
      createdAt
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SubCategoriesByCategoryIdQueryVariables,
  APITypes.SubCategoriesByCategoryIdQuery
>;
export const subCategoriesByCompanyId = /* GraphQL */ `query SubCategoriesByCompanyId(
  $companyId: String!
  $filter: ModelSubCategoryFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  subCategoriesByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      categoryId
      companyId
      createdAt
      id
      name
      owner
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SubCategoriesByCompanyIdQueryVariables,
  APITypes.SubCategoriesByCompanyIdQuery
>;
export const tireReportsByCompanyId = /* GraphQL */ `query TireReportsByCompanyId(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelTireReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  tireReportsByCompanyId(
    companyId: $companyId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      equipmentLocationId
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      tireId
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TireReportsByCompanyIdQueryVariables,
  APITypes.TireReportsByCompanyIdQuery
>;
export const tireReportsByEquipmentCategoryId = /* GraphQL */ `query TireReportsByEquipmentCategoryId(
  $createdAt: ModelStringKeyConditionInput
  $equipmentCategoryId: String!
  $filter: ModelTireReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  tireReportsByEquipmentCategoryId(
    createdAt: $createdAt
    equipmentCategoryId: $equipmentCategoryId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      equipmentLocationId
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      tireId
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TireReportsByEquipmentCategoryIdQueryVariables,
  APITypes.TireReportsByEquipmentCategoryIdQuery
>;
export const tireReportsByTireId = /* GraphQL */ `query TireReportsByTireId(
  $filter: ModelTireReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $tireId: String!
) {
  tireReportsByTireId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    tireId: $tireId
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      equipmentLocationId
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      tireId
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TireReportsByTireIdQueryVariables,
  APITypes.TireReportsByTireIdQuery
>;
export const tireReportsByUnitId = /* GraphQL */ `query TireReportsByUnitId(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelTireReportFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $unitId: String!
) {
  tireReportsByUnitId(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    unitId: $unitId
  ) {
    items {
      alwaysTriggerEmail
      companyId
      createdAt
      equipmentCategoryId
      equipmentCategoryName
      equipmentLocationId
      id
      inspectionCompleted
      inspectionStarted
      name
      signature
      tireId
      unitId
      unitName
      updatedAt
      userData
      userId
      userLocation
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TireReportsByUnitIdQueryVariables,
  APITypes.TireReportsByUnitIdQuery
>;
export const trainingQuizResponsesByCompanyId = /* GraphQL */ `query TrainingQuizResponsesByCompanyId(
  $companyId: String!
  $filter: ModelTrainingQuizResponseFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  trainingQuizResponsesByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      attemptNumber
      categoryId
      companyId
      completedAt
      createdAt
      cycleStartDate
      formId
      id
      owner
      passed
      planId
      responseData
      score
      signaturePath
      totalQuestions
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TrainingQuizResponsesByCompanyIdQueryVariables,
  APITypes.TrainingQuizResponsesByCompanyIdQuery
>;
export const trainingQuizResponsesByUserId = /* GraphQL */ `query TrainingQuizResponsesByUserId(
  $filter: ModelTrainingQuizResponseFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  trainingQuizResponsesByUserId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      attemptNumber
      categoryId
      companyId
      completedAt
      createdAt
      cycleStartDate
      formId
      id
      owner
      passed
      planId
      responseData
      score
      signaturePath
      totalQuestions
      updatedAt
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TrainingQuizResponsesByUserIdQueryVariables,
  APITypes.TrainingQuizResponsesByUserIdQuery
>;
export const userFilesByCompanyId = /* GraphQL */ `query UserFilesByCompanyId(
  $companyId: String!
  $filter: ModelUserFileFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  userFilesByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      createdAt
      fileName
      fileSize
      id
      owner
      s3Path
      updatedAt
      uploadedAt
      uploadedBy
      uploadedByName
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserFilesByCompanyIdQueryVariables,
  APITypes.UserFilesByCompanyIdQuery
>;
export const userFilesByUserId = /* GraphQL */ `query UserFilesByUserId(
  $filter: ModelUserFileFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: String!
) {
  userFilesByUserId(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      companyId
      createdAt
      fileName
      fileSize
      id
      owner
      s3Path
      updatedAt
      uploadedAt
      uploadedBy
      uploadedByName
      userId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserFilesByUserIdQueryVariables,
  APITypes.UserFilesByUserIdQuery
>;
export const usersByCognitoId = /* GraphQL */ `query UsersByCognitoId(
  $cognitoId: String!
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  usersByCognitoId(
    cognitoId: $cognitoId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      archived
      cognitoId
      companyId
      contactPhoneNumber
      contactPhoneType
      createdAt
      currentJobClassification
      dateOfHire
      discrepancyNotification
      discrepancyNotificationTypes
      domain
      driversLicenseStatus
      email
      globalLocationPermission
      id
      inputByPerson
      inputDate
      locationAssignment
      name
      notesAboutUser
      onHighwayEligibility
      owner
      permissions
      personalIdentification
      pmNotification
      pmNotificationTypes
      position
      regionalAssignment
      role
      safetyLessons
      skillTrackingModuleEnrollment
      trainingModuleEnrollment
      trainingNotification
      trainingNotificationTypes
      updatedAt
      userPhoto
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByCognitoIdQueryVariables,
  APITypes.UsersByCognitoIdQuery
>;
export const usersByCompanyId = /* GraphQL */ `query UsersByCompanyId(
  $companyId: String!
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  usersByCompanyId(
    companyId: $companyId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      archived
      cognitoId
      companyId
      contactPhoneNumber
      contactPhoneType
      createdAt
      currentJobClassification
      dateOfHire
      discrepancyNotification
      discrepancyNotificationTypes
      domain
      driversLicenseStatus
      email
      globalLocationPermission
      id
      inputByPerson
      inputDate
      locationAssignment
      name
      notesAboutUser
      onHighwayEligibility
      owner
      permissions
      personalIdentification
      pmNotification
      pmNotificationTypes
      position
      regionalAssignment
      role
      safetyLessons
      skillTrackingModuleEnrollment
      trainingModuleEnrollment
      trainingNotification
      trainingNotificationTypes
      updatedAt
      userPhoto
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByCompanyIdQueryVariables,
  APITypes.UsersByCompanyIdQuery
>;
